import { Component, OnInit,ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import {FormControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { fuseAnimations } from '@fuse/animations';
import { datosProductos } from './survey-status.tree';
import {datosProductosCatalogo} from './survey-status.tree';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { AuthService } from 'app/auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';
import { lang_avances } from 'app/idiomas/i18n/avances/avances.lang';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import {MatTableDataSource} from '@angular/material/table';
import { SurveyStatusService } from "./survey-status.service";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Inject} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import * as colabInter from 'app/main/pagina/encuestador-n35/colaboradores35/colaboradores35.interface';
import * as colabInterBD from './nuevo-colaborador/catalogoColumnas';
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import { saveAs } from 'file-saver';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { NuevoColaboradorComponent } from "./nuevo-colaborador/nuevo-colaborador.component";
import { AccionesComponent } from "./nuevo-colaborador/acciones/acciones.component";
import { SheduleService } from "app/main/pagina/productos/certificar/tipo_1/services/shedule.service";
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { ProgramacionN35Service} from 'app/main/wizard-n35encuestador/services/programacionn35.service';
import { CierreService } from 'app/main/wizard-cgo/services/cierre.service';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_toolbar } from 'app/idiomas/i18n/toolbar/toolbar.lang';
import { Envion35Service } from 'app/main/wizard-n35encuestador/services/envion35.service';
// import {DownloadDialog} from 'app/main/pagina/tools/gestUsu/detail/detail.component';
import {DescargaEncuestaComponent} from 'app/main/pagina/tools/gestUsu/detail/descarga-encuesta/descarga-encuesta.component';
const moment = require('moment');
const momentTz = require('moment-timezone');
import *  as $ from 'jquery';
import { institutos } from '../../../../idiomas/i18n/perfiles/catalogos/en';
import { SendGridService } from '../sendgrid-log/sendgrid-log.service';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import { zonasUTC } from 'app/main/pagina/zonasUtc';
export interface DialogData {
  SurveyId:any,
  surveyKey:any,
  idEmpresa:any,
  idSurveyMas?: any,
  idSurveyMenos?: any,
}

export interface DialogDataEmail {
  email?:any,
  username?:any,
  tipo?:any,
  idEmpresa?:any,
  idProducto?:any,
  encuestaId?:any
  tipoProducto?:any,
  tokenConfig:any,
  instituto:any,
  fecha:any,
  estadoEncuesta?:any,
  fechaLanzamiento?:any,
  cerrarEncuesta?:any
}

export interface DialogDataSurvey {
  SurveyId:any,
  idEmpresa:any,
  idSurveyMas?: any,
  idSurveyMenos?: any,
}
export interface resultado{
  email: string,
  fullName: string,
  surveyKey: string,
  _id: string,
  estado?:string,
}

export interface resultado_nuevo{
  email: string,
  end_date: string,
  id_status: number,
  name: string,
  start_date: string,
}

export interface resultadoFocus{
  BrokerID: string,
  HierarchicalPath: string,
  IdUser: number,
  Institute: number,
  NameUser: string,
  NeedHelp: number, // 0 no 1 es que sí
  RowID: number,
  SecciónI?: number,
  SecciónII?: number,
  SecciónIII?: number,
  SecciónIV?: number,
  surveyToken: string,
  email?:string,
  encuestaId?:string,
  fullName?:string,
}
interface FoodNode {
  translate:string, // Auth idiomas
  id:string,
  name: string,
  hidden: boolean,
  idProducto?:any,
  anio?:any,
  idSurvey?:any,
  idSurveyMas?: any,
  idSurveyMenos?: any,
  children?: FoodNode[]
}
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

interface ProductosNodetmp {
  translate?:string, // Auth idiomas
  id?:string,
  name: string,
  hidden?: boolean,
  idProducto?:any,
  anio?:any,
  idSurvey?:any,
  children?: ProductosNodetmp []
}

export interface Data {
  datos:any,
  valorAsunto:any,
  noHistorial:boolean,
  correo:string
}


@Component({
  selector: 'app-survey-status',
  templateUrl: './survey-status.component.html',
  styleUrls: ['./survey-status.component.scss'],
  animations : fuseAnimations
})
export class SurveyStatusComponent implements OnInit {

  //@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  //@ViewChild(MatSort, {static: true}) sort: MatSort;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  mostrarTabla:boolean=false;
  busqueda: string = "";
  paginaActual: number;
  totalEmpresas: number;
  nextPag: number;
  prevPag: number;
  contadorInicio: number;
  contadorFin: number;
  idProducto_tmp:any;
  search:string='';
  Nousers:boolean=false;

  product_name:any;

  nombresColumnasheader = ['name','email','copy','surveyid','status','fecha','accion'];
  nombresColumnasCont = ['name','email','copy','surveyid','status','fecha','accion'];

  nombresColumnasheader_focus = ['name','email','status','accion','accion2','accion3'];
  nombresColumnasCont_focus   = ['name','email','status','accion','accion2','accion3'];

  filtros = [
    "AVANCES.TITULOS.ESTADOS_ENC.ESTADO1",
    "AVANCES.TITULOS.ESTADOS_ENC.ESTADO2",
    "AVANCES.TITULOS.ESTADOS_ENC.ESTADO3",
    "AVANCES.TITULOS.ESTADOS_ENC.ESTADO4",
  ];
  resultadosUsuario:any [] = [];
  mostrarSeccion:boolean=false;
  SurveyId:any;
  SurveyIdMas:any=null;
  SurveyIdMenos:any=null;
  cargando=false;
  hasNorma:boolean=false;
  producto:any;
  dataSource: MatTableDataSource<resultado>;
  dataSource_nuevo: MatTableDataSource<resultado_nuevo>;
  dataSource_focus: MatTableDataSource<resultadoFocus>;
  ArrayProducto: ProductosNodetmp [] = [];
  showFiller = false;
  dataSourceTree:any;
  treeControl:any;
  arbolProductos: any;
  treeFlattener:any;
  datosUsu: backInter.infoUsuario;
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  cargaCompleta:boolean=false;
  idEmpresa:any;
  listaProdsCertificar: any[] = [];
  listaProdsMedir: any[] = [];
  datosProd: backInter.infoProductos;
  currentStep:any;
  show:boolean=true;
  bloqueTotal:boolean=true;//No debe cambiar
  mensajesTraducirKeys: string[] = [
    'AVANCES.COLUMNAS.email',
    'AVANCES.COLUMNAS.end_date',
    'AVANCES.COLUMNAS.id_status',
    'AVANCES.COLUMNAS.name',
    'AVANCES.COLUMNAS.start_date',
    'AVANCES.ENCUESTA.DESCARGAR',// Columna 6
    'AVANCES.ENCUESTA.TITULOEXCEL',// Columna 7
  ];
  //variables que tomaran las traducciones indicadas en la variable anterior
  //deben ir en el mismo orden
  mensajesTraducirTS = {
    columna1:'',
    columna2:'',
    columna3:'',
    columna4:'',
    columna5:'',
    columna6:'', //Descargar excel
    columna7:'', // Titulo de excel
  };

  nombreProductoSel: string;
  token:string;
  añoProducto:any;
  fechaLanzamiento:any;
  fechaCierre:any;
  btnProrroga=false;
  prorrogasGuardas:any;
  sinProrrogas=false;////variable que permite visualizar la fecha en caso de que alla prorroga
  permisoProrroga:boolean; ///variable que permitira cerrar o  dar prorroga por instituto
  statusEncuesta:number;//variable que habilita btn cerrarEncuesta o abrirEncuesta
  banderaCerrarProrroga: boolean=false; //variable que habilita botones cerrarEncuesta & prorroga por instituto
  idSurveySincronizar:any;
  productoIdSincronizar:any;
  datosSurveyCheck:any;
  fechaProrroga:any;
  //zonas horarias
  zonasUTC = zonasUTC;
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string;
  fechaProrrogaBackUtc0:any;

  ultimoProducto: any = {};
  filtroLanzamiento:any;
  filtroCierreProrroga:any;
  fechaValueProrroga:any;

  btnRecordatoriosProd3:boolean;
  aniosFocusAgregados: any[]=[];
  clavesConteos: backInter.getClaveConteos;
  claveConteos:string;
  rutaPagina: string;
  tipoProductoClaveConteos:number=0;
  mostrarBtnCopyEnl:boolean=false;


  constructor(
    private _formBuilder: FormBuilder,
    private activatedRoute : ActivatedRoute,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public authService: AuthService,
    private http:HttpClient,
    private surveyServ: SurveyStatusService,
    private colaboradoresService: ColaboradoresEncuestadorService,
    public dialog: MatDialog,
    public dialogSurvey: MatDialog,
    private sheduleService: SheduleService,
    private programacionService: ProgramacionService,
    private programacionService35: ProgramacionN35Service,
    private cierreService: CierreService,
    private encuestaService: EncuestaService,
    private router: Router,
    private odsService: ODSService,
    private envioService: Envion35Service,
  ) {
    this.currentStep = 0;
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
    });
    lang_avances.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_cierre.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_toolbar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.reiniciaVariables();
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
   }
  nombreEmpresa:any;
  m1_check:boolean;
  cityname:any;

  ngOnInit() {
    this.m1_check=false;
    this.reiniciaVariables();
    this.getProductos();
    this.getDatosSidebar();
    this.traduceTextosTS();
    this.busqueda='';
    console.log("Indice "+localStorage.getItem('instituto_id'));
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == parseInt(localStorage.getItem('instituto_id')));
    /*let city_name = 'TOOLBAR.CITIES.'+''+localStorage.getItem('instituto_id') ;
    localStorage.setItem('nameCity_surveystatus',''+city_name);
    this.cityname=city_name;
    console.log("Ciudad "+this.cityname);*/
    this.calculoOffsetPipe();
  }

  cierreManual(){
    let datos = {
      empresaId: this.idEmpresa,
      productoId: this.idProducto_tmp,
    };
    this.surveyServ.cierreManual(datos).subscribe((respuesta:any) => {
      console.log("cierreManual:",respuesta);
      if(respuesta.success){
        Swal.fire({
          title: this.translateSrv.instant('AVANCES.PROCESAR.OK'),
          icon: "success",
          confirmButtonColor: '#e40601'
        });
      } else{
        Swal.fire({
          title: this.translateSrv.instant('AVANCES.PROCESAR.NOTOK'),
          icon: "warning",
          confirmButtonColor: '#e40601'
        });
      }
    });
  }

  descargaExcelColaboradores(){
    Swal.fire({
      title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXCEL'),
      didOpen: () => {
        Swal.showLoading()
      }
    });
    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.TITULO'),
      Subject: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.ASUNTO'),
      Author: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.AUTOR'),
      CreatedDate: new Date()
    };

    wb.SheetNames.push(this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.HOJA'));
    var ws_data = [];
    var columnaVacia=[];
    let nombresColumnas:string[] = [];

    this.surveyServ.getColaboradoresFull(this.idEmpresa, this.idProducto_tmp).subscribe( (getFull: any) => {
      if(getFull.message == 'Success' && getFull.bdcolaboradores.length > 0){
        colabInterBD.CLAVES_COLUMNAS.forEach( (nombre,i) =>{

          if(getFull.columnas[nombre.clave]){
            nombresColumnas.push(getFull.columnas[nombre.clave]);
          }
          else{
            columnaVacia.push(i);
          }
        });
        ws_data.push(nombresColumnas);

        getFull.bdcolaboradores.forEach( (colaborador) => {
          let datosColaboradores:any[] = [];
          colabInterBD.CLAVES_COLUMNAS.forEach( (nombre,i) => {

            if(!columnaVacia.includes(i)){
              if(colaborador[nombre.clave]){
                switch (colaborador[nombre.clave]) {
                  case 'antiquity': case 'enterDate':
                  datosColaboradores.push(this.fechaCorrecta(colaborador[nombre.clave]));
                  break;
                  default:
                  datosColaboradores.push(colaborador[nombre.clave].toString());
                  break;
                }
              }
              else{
                if(nombre.clave == 'bossKey'){
                  datosColaboradores.push('0');
                }
                else{
                  datosColaboradores.push('');
                }
              }
            }
          });
          ws_data.push(datosColaboradores);
        });

        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.HOJA')] = ws;
        var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
        var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

        saveAs(new Blob([buf],{type:"application/octet-stream"}), this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.TITULO')+' - '+this.nombreEmpresa+'.xlsx');
        Swal.close();
      }
    });
  }

  fechaCorrecta(fechaActual:any){
    let fechaFinal: string;
    if(isNaN(fechaActual)){
      fechaFinal = fechaActual;
    }
    else{
      let fechaInicial = "30-12-1899";
      let fechaReal = moment(fechaInicial, "DD-MM-YYYY");
      fechaReal.add(fechaActual, 'days');
      fechaFinal = moment(fechaReal).format('DD/MM/YYYY');
    }
    return fechaFinal;
  }

  verCloud(){
    // console.log({id: this.idEmpresa, idprod: this.idProducto_tmp});
    this.router.navigate(['/companies/detail',this.idEmpresa,this.idProducto_tmp,'file-manager']);
  }
  codigoDeProyecto:any;
  enterpriseData:any;
  obtenerCodigo(idEnterprise){
    this.odsService.getEnterpriseDetail(idEnterprise)
      .subscribe(response => {
        console.log("getEnterpriseDeailt");
        console.log(response);
        this.enterpriseData = response['data'];
        this.codigoDeProyecto=this.enterpriseData['codigoProyecto'];

      }, error => {
        console.log("error", error);
      });
  }


  verCloudPublico(){
    this.router.navigate(['/file-manager',this.idEmpresa,this.idProducto_tmp]);
  }

  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
    localStorage.setItem("offsetPipe_tmp",''+this.offsetPipe);
  }

  showbotton(){
    $(function(){
      $(".btn-toggle-menu").click(function() {
        $("#wrapper").toggleClass("toggled");
      });
    })
  }

  datosEmp;any;
  rutaimagen:any;
  array_lista:any[]=[];
  filtros_status(idStatus){

    let instituto = parseInt(localStorage.getItem('instituto_id'));
    if(this.hasNorma){
      this.noEncuesta=false;
      this.surveyServ.desColaboradores(this.SurveyIdMenos,this.SurveyIdMas,2,instituto).subscribe( (data: backInter.resultExcel) => {

        this.data_users(data,idStatus);
      });
    }else if(this.SurveyId){
      this.noEncuesta=false;
      this.surveyServ.desColaboradores(this.SurveyId,0,1,instituto).subscribe( (data: backInter.resultExcel) => {

          this.data_users(data,idStatus);
      }, error  => {
        console.log("error");
      });
    }

  }
  sincronizarPortalConteos(){
    let sicronizando="AVANCES.SINCRONIZACION.SINCRONIZANDO";
    let sincronizacionCompleta="AVANCES.SINCRONIZACION.SUCCESS";
    let cerrar="AVANCES.BOTONES-MODALES.ELIMINAR.CERRAR";
    this.translateSrv.get(sicronizando).subscribe((res: string) => { sicronizando = res; });
    this.translateSrv.get(sincronizacionCompleta).subscribe((res: string) => { sincronizacionCompleta = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    Swal.fire({
      title: sicronizando,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    let datos={
      brokerId:localStorage.getItem('instituto_id'),
      idSurvey:this.idSurveySincronizar,
      productoId:this.productoIdSincronizar
    }
    this.surveyServ.sincronizarConteos(datos).subscribe((data:backInter.sincronizacionPortalConteos) => {
      console.log(data);
      Swal.close();
      if(data.success==true){
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: sincronizacionCompleta,
          showConfirmButton: true,

          confirmButtonText: cerrar
        })
      }
    }, error  => {
      console.log("error");
    });
  }

  activeSurvey:boolean;
  validarEncuesta(){
    console.log("Entro");
    if(this.tokenConfig){
      this.programacionService.surveyCheck(this.tokenConfig).subscribe((respuesta:any) => {
        console.log(respuesta);
        this.datosSurveyCheck=respuesta.result;
        console.log(this.datosSurveyCheck.length);
        if(this.datosSurveyCheck.length == 0){
          this.activeSurvey=true;
        }else{
          if(this.datosSurveyCheck[1].value == "0"){
            this.activeSurvey=false;
          }else{
            this.activeSurvey=true;
          }
        }

        console.log("Valor "+this.activeSurvey);
      }, error => {
        console.log("Survey check services error");
        console.log(error);
      });
    }

  }

  surveyCheckService(){
    this.programacionService.surveyCheck(this.tokenConfig).subscribe((respuesta:any) => {
      this.datosSurveyCheck=respuesta.result;
      this.surveyCheck();
    }, error => {
      console.log("Survey check services error");
      console.log(error);
    });
  }

  surveyCheck(){
    const dialogRef = this.dialog.open(SurveyCheckComponent, {
      width: '40%',
      data: {
        datos: this.datosSurveyCheck
      }
    });
  }

    dialogFechaProrroga(idProd,idEmp,fechaProrrogaBackUtc0,tok){
      localStorage.setItem('idProd',idProd);
      localStorage.setItem('idEmp',idEmp);
      localStorage.setItem('fechaProrrogaBackUtc0',fechaProrrogaBackUtc0);
      localStorage.setItem('tok',tok);

      const dialogRef = this.dialog.open(FechaProrrogaComponent, {
        width: '40%',
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
        this.getProrrogasFechasCierre(this.idProducto_tmp);
      });
    }

    dialogDate_message(fecha){
      localStorage.setItem('fechamessage',''+fecha);
      localStorage.setItem('offsetPipe_message',''+this.offsetPipe);
      const dialogRef = this.dialog.open(DateMessageComponent, {
        width: '40%',
      });
    }

  reiniciaVariables(){
    localStorage.setItem('Surveystaus_portal','false');
    this.datosProd = null;
    this.ArrayProducto=null;
    this.dataSourceTree=null;
    this.treeControl=null;
    this.treeFlattener=null;
    this.treeControl = [];
    this.treeFlattener = [];
    this.dataSourceTree = [];
    this.dataSourceTree.data = []
    this.ArrayProducto=[];
  }
  getDatosSidebar(){
    console.log("Empresa "+this.idEmpresa);
    this.surveyServ.getInfoEmpresa(this.idEmpresa).subscribe((data:backInter.infoEmpresa) => {
      this.datosEmp = data;
      this.nombreEmpresa=this.datosEmp.data.nombreEmpresa;
      let url = DATOS_API.url.split(":");
      this.rutaimagen= url[1]+"/surveyadministrator/backend/"+data.data.logoEmpresa;
      console.log(this.datosEmp);
      // Datos
      let city_name = 'TOOLBAR.CITIES.'+''+this.datosEmp.data.institutoEmpresa;
      console.log("Instituto "+this.datosEmp.data.institutoEmpresa);
      localStorage.setItem('instituto_empresa',''+this.datosEmp.data.institutoEmpresa);
      localStorage.setItem('nameCity_surveystatus',''+city_name);
      this.cityname=city_name;
      console.log("Ciudad "+this.cityname);

    }, error  => {
      console.log("error");
    });

  }
  numSeccion=0;
  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      translate: node.translate,
      hidden:node.hidden,
      anio:node.anio,
      idProducto:node.idProducto,
      id:node.id,
      idSurvey:node.idSurvey,
      level: level,
      idSurveyMas: node.idSurveyMas,
      idSurveyMenos: node.idSurveyMenos,
    };
  }

  getProductos(){
    let datosUsu = this.authService.getInfoUsuario();
    this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa )
      .subscribe((data:backInter.infoProductos) => {
        console.log(data);
        this.datosProd = data;
        this.filtraProductos();
    }, error  => {
      console.log("error");
    });
  }

  CertificarSurvey:any;
  arrayCertificar:any[]=[];
  arrayCertificar3:any[]=[];
  arrayMedir:any[]=[];
  arrayMedir3:any[]=[];
  arrayMedirGenerico:any[]=[];
  arrayNorma:any[]=[];
  arrayPulse:any[]=[];
  arrayPulse3:any[]=[];
  arrayFocus:any[]=[];
  arrayFocusv3:any[]=[];
  arrayCulturalGoExpress:any[]=[];
  medir_checked:boolean=false;
  pulse_checked:boolean=false;
  norma035_checked:boolean=false;
  focus_checked:boolean=false;

  filtraProductos(){
    this.arrayCertificar=[];
    this.arrayCertificar3=[];
    this.arrayMedir=[];
    this.arrayMedir3=[];
    this.arrayMedirGenerico=[];
    this.arrayNorma=[];
    this.arrayPulse=[];
    this.arrayPulse3=[];
    this.arrayFocus=[];
    this.arrayFocusv3=[];
    this.arrayCulturalGoExpress=[];
    this.ArrayProducto=[];
    if(this.datosProd.productosCertificar.length > 0){ // Pos 0
      this.datosProd.productosCertificar.forEach(producto => {
        console.log("tipoProducto",producto);
        if (producto.idProducto!=41 && producto.idProducto!=42 && producto.idProducto!=40 && producto.idProducto!=43) {
        switch (producto.tipo) {
          case 1:

            this.arrayCertificar.push(producto);

          break;
          case 2:
          this.arrayCertificar.push(producto);

          break;
          case 3:

            this.arrayCertificar.push(producto);

          break;
          case 4:

            this.arrayCertificar.push(producto);

          break;
        }
      }
        if (producto.idProducto==41) {
          this.arrayMedir3.push(producto);
        }else if(producto.idProducto==42){
          this.arrayPulse3.push(producto);
        }else if(producto.idProducto==40){
          this.arrayCertificar3.push(producto);

        }else if(producto.idProducto==43) {
          this.arrayFocusv3.push(producto)
        }
      });
      console.log('this.arrayMedir3',this.arrayMedir3);
      console.log('this.arrayCertificar',this.arrayCertificar);
      console.log('this.arrayPulse3',this.arrayPulse3);
      console.log(localStorage.getItem('tipoProducto'));

        this.aniosFocusAgregados=[];
          let fechaActual:number;
          let fechaPulse:any[]=[];
          let anioNoSeleccionados:any[]=[];


      this.arrayFocusv3.forEach(anioAgregado => {
        // console.log('anioAgregado',anioAgregado);

        anioNoSeleccionados.push(anioAgregado);

      });

          anioNoSeleccionados.sort( (a,b) => {
            if(a.fechaCertificar > b.fechaCertificar){
              return 1;
            } else{
              return -1;
            }
          });
          console.log(anioNoSeleccionados);
          anioNoSeleccionados.forEach((element,i) => {
            // console.log('element',element);

            // console.log(element.completoCertificar);
            if(fechaActual){
              if(element.fechaCertificar == fechaActual){
                // fechaPulse.push(element);
                fechaPulse.push(element);
              }
              else {
                this.aniosFocusAgregados.push({fecha: fechaActual, datos: fechaPulse });
                fechaPulse=[];
                fechaActual=element.fechaCertificar;
                // fechaPulse.push(element);
                fechaPulse.push(element);
              }
            }
            else{
              fechaActual=element.fechaCertificar;
              // fechaPulse.push(element);
              fechaPulse.push(element);
            }
            fechaPulse.sort( (a,b) => {
              if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
            });
            if(anioNoSeleccionados.length ==(i+1)){
              this.aniosFocusAgregados.push({fecha: element.fechaCertificar, datos: fechaPulse});
            }
          });
        console.log('this.aniosFocusAgregados',this.aniosFocusAgregados);










    }
    if(this.datosProd.productosMedir.length > 0 || this.datosProd.productosMedir2.length > 0 ){ // Pos 1
      this.datosProd.productosMedir.forEach(producto => {
        this.arrayMedir.push(producto);
      });
      this.datosProd.productosMedir2.forEach(producto => {
        this.arrayMedirGenerico.push(producto);
      });
    }
    if(this.datosProd.productosPulseCheck.length > 0){ // Pos 2
      this.datosProd.productosPulseCheck.forEach(producto => {
        this.arrayPulse.push(producto);
      });

    }


    if(this.datosProd.productosFocusArea.length > 0){ // Pos 3
      this.datosProd.productosFocusArea.forEach(producto => {
        this.arrayFocus.push(producto);
      });
    }
    if(this.datosProd.productosNorma35.length >= 0) { // Post 4
      this.datosProd.productosNorma35.forEach(producto => {
        this.arrayNorma.push(producto);
      });
console.log('this.arrayNorma',this.arrayNorma);


     if (this.datosProd.productosCGOExpress.length >= 0) {
       this.datosProd.productosCGOExpress.forEach(producto => {
         this.arrayCulturalGoExpress.push(producto);
       });
     }
console.log('this.arrayCulturalGoExpress',this.arrayCulturalGoExpress);
    }
    this.cargaCompleta=true;
    if(localStorage.getItem('BACK_PORTAL') == 'Activo'){
      localStorage.setItem('BACK_PORTAL','Inactivo');
      let idProducto=localStorage.getItem('productoID');
      if(idProducto){
        let elemento=0;


        switch (localStorage.getItem('tipoProducto')) { // PAra asignar nombre al producto
          case '1': case 'c1': case 'c3':
            console.log("Entro m1");
            this.m1_check=true;
            this.datosProd.productosCertificar.forEach(producto => {
              console.log('producto**************',producto);

            if(idProducto == producto.idCertificar){
              this.obtenerData(producto.nombreProducto,producto.fechaCertificar, producto.idCertificar,elemento,producto.idSurvey,'','','Certificar','NAV.CERTIFICAR.TITULO',producto.tokenConfig);
              localStorage.setItem('BACK_PORTAL','Inactivo');
            }
            elemento++;
            });
          break;
          case 'm1': case 'm2': case 'm3': case 'm4': case 'm5': case 'm6':
            this.medir_checked=true;
          this.datosProd.productosMedir2.forEach(producto => {
            if(idProducto == producto.idProducto){
              let nombreCer='NAV.MEDIR.SUBPRODUCTOS.'+producto.tipo;
              let nombre_medir;
              switch(producto.tipo){
                case 1: nombre_medir = 'Medir mejorador'; break;
                case 2: nombre_medir = 'Medir MTS'; break;
                case 3: nombre_medir ='Medir áreas'; break;
                case 4: nombre_medir ='Medir líderes'; break;
                case 5: nombre_medir ='Medir dimencione'; break;
                case 6: nombre_medir ='Medir certificar'; break;
              }
              this.obtenerData(nombreCer,producto.fechaProducto,producto.idProducto,elemento,producto.idSurvey,'','','Medir',nombreCer,producto.tokenConfig);
              localStorage.setItem('BACK_PORTAL','Inactivo');
            }
            elemento++;
          });
        break;
        case '2':
          this.medir_checked=true;
          this.datosProd.productosMedir.forEach(producto => {
            if(idProducto == producto.idMedir){
              let nombreCer='NAV.MEDIR.SUBPRODUCTOS.0';
              this.obtenerData(nombreCer,producto.fechaMedir, producto.idMedir,elemento,producto.idSurvey,'','','Medir',nombreCer,producto.tokenConfig);
              localStorage.setItem('BACK_PORTAL','Inactivo');
            }
            elemento++;
          });
        break;
        case '3':
          this.pulse_checked=true;
          this.datosProd.productosPulseCheck.forEach(producto => {
            if(idProducto == producto.idPulseCheck){
              let nombreCer='NAV.PULSE.TITULO';
              this.obtenerData(nombreCer,producto.fechaPulseCheck, producto.idPulseCheck,elemento,producto.idSurvey,'','','PulseCheck',nombreCer,producto.tokenConfig);
              localStorage.setItem('BACK_PORTAL','Inactivo');

            }
            elemento++;
          });
        break;
        case '4':
          this.focus_checked=true;
          this.datosProd.productosFocusArea.forEach(producto => {
            if(idProducto == producto.idFocusArea){
              let nombreCer='NAV.MEDIR.SUBPRODUCTOS.0';
              this.obtenerData(nombreCer,producto.fechaFocus, producto.idFocusArea,elemento,producto.idSurvey,'','','Focus Area',nombreCer);
              localStorage.setItem('BACK_PORTAL','Inactivo');
            }
            elemento++;
          });
        break;
        case '5':
          this.norma035_checked=true;
          this.datosProd.productosNorma35.forEach(producto => {
            if(idProducto == producto.idNorma35){
              let nombreCer='NAV.PULSE.TITULO';
              this.obtenerData(nombreCer,producto.fechaNorma35, producto.idNorma35,elemento,'',producto.idSurveyMenos,producto.idSurveyMas,'Nom035','NAV.NORMA35.TITULO');
              localStorage.setItem('BACK_PORTAL','Inactivo');
            }
            elemento++;
          });
        break;


        default:   break;
      }
      }

    }
  }

  obtenerPos(arregloDatos:any, producto:any){
    let pos=0;
    for(let i=0; i< arregloDatos.length; i++){
      if(arregloDatos[i].id == producto){
        pos=i;
        return pos;
      }
    }
  }

  getUrlCode(number?){
    if(number== 1){
      let data={
        fechaCertificar: this.fechaProducto
      };
      this.encuestaService.getPilotoDataEncuesta_estatus(data,this.idEmpresa).subscribe((data: any) => {
        console.log("getPilotoData:",data);

      });
    }

  }

  copyMessage(val: any){ // Función para copiar clave
    let valor:any;
    let texto = 'CIERRE.CIERRE.COPYLINK';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    valor =  val;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value=valor;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    Swal.fire({
      icon: 'success',
      title: texto,

    });

  }

  noEncuesta:boolean;
  nombreSecundario:any;
  hasFocus:boolean;
  idFocus:any;
  idFocus_config:any;
  tokenConfig:any;
  fechaProducto:any;
  nombreProducto:any;
  total_usuarios:any;
  tipoproducto:any;
  plantilla:any;
  menos50:boolean;
  mas50:boolean;
  Certificar_tipoProducto:any;
  porcentaje1:any;
  porcentaje2:any;
  dataTmp1:any; dataTmp2:any;
  tipoProductoSeleccionado:number;


  obtenerData(nombreProducto, anio, productoId,elem,idSurvey,idSurveyMenos?,idSurveyMas?,nombre?,nombreSecundario?,tokenConfig?,tipoproducto?,plantilla?,tipoProductoId?){
    console.log('nombreProducto idSurveyMenos',idSurveyMenos);
    console.log('nombreProducto idSurveyMas',idSurveyMas);
    console.log('nombreProducto SELECCIONADO',nombreProducto);
    console.log('productoID SELECCIONADO',tipoProductoId);
    this.tipoProductoSeleccionado= tipoProductoId;
    if(this.tipoProductoSeleccionado==40 || this.tipoProductoSeleccionado==41 || this.tipoProductoSeleccionado==42 || this.tipoProductoSeleccionado==43) {
      this.btnRecordatoriosProd3=true;
      console.log('es producto 3.0');

    }else{
      this.btnRecordatoriosProd3=false;
    }
    this.encuesta_cerrada=false; //Se reinicia en false, ya que al cambiar de productos la bandera no sé actualiza
    this.bloquearBotonReminder=false;//Se reinicia en false, ya que al cambiar de productos la bandera no sé actualiza
    this.cargando=false;//Se reinicia en false, ya que al cambiar de productos la bandera no sé actualiza
    this.bloquearBotonReminder=false; //Se reinicia en false, ya que al cambiar de productos la bandera no sé actualiza
    this.statusEncuesta=0;
    this.Certificar_tipoProducto=tipoproducto;
    this.dataSource_nuevo=null;
    //console.log("Survey mas "+idSurveyMas);
    localStorage.setItem('idEmpresa_surveysatus',''+this.idEmpresa);
    localStorage.setItem('companyID',''+this.idEmpresa);
    localStorage.setItem('Surveystaus_portal','activo');
    localStorage.setItem('productoID',''+productoId)
    this.idProducto_tmp=productoId;
    this.noEncuesta=null;
    this.hasFocus=false;
    this.hasNorma=false;
    this.mostrarSeccion=false;
    this.nombreProducto=nombreProducto;
    if(tipoProductoId!=52){
      this.getProrrogasFechasCierre(this.idProducto_tmp);
    }
    let instituto_survey = parseInt(localStorage.getItem('instituto_id'));
    if(idSurvey != undefined || this.nombreProducto=="NAV.FOCUS.TITULO"){// Si no existe el id Survey no se pueden ejecutar los demas servicios
      console.log("idSurvey "+idSurvey);
      localStorage.setItem('idSurvey_status',''+idSurvey);
      this.tokenConfig=tokenConfig;
      console.log("token "+this.tokenConfig);
      this.fechaProducto=anio;
      this.ultimoProducto = {
        nombreProducto, anio, productoId, elem, idSurvey, idSurveyMenos, idSurveyMas, nombre, nombreSecundario
      };
      this.idSurveySincronizar=idSurvey;
      this.productoIdSincronizar=productoId;
      this.nombreSecundario=nombreSecundario;
      if(nombreProducto == "NAV.FOCUS.TITULO"){
        this.hasFocus=true;
        this.hasNorma=false;
        this.activeSurvey=true;
      }else if(nombreProducto == "NAV.NORMA35.TITULO"){
        this.hasNorma=true;
        this.hasFocus=false;
        this.activeSurvey=true;
        localStorage.setItem('fechaProducto',this.fechaProducto);
        this.getFechaLanzamientoNorma(this.fechaProducto);
        if(idSurveyMenos){
          this.SurveyIdMenos=idSurveyMenos;
          this.idSurveySincronizar=idSurveyMenos;
          this.menos50=true;
          this.surveyServ.Normaclosesurvey(this.idProducto_tmp,1,this.idEmpresa).subscribe((data:backInter.surveyprogress) => {
            console.log("Porcentajes menos de 50");
            this.dataTmp2=data.avance;
            this.porcentaje2=this.dataTmp2.porcentaje;
          });
        }
        if(idSurveyMas){
          this.SurveyIdMas=idSurveyMas;
          this.idSurveySincronizar=idSurveyMas;
          this.mas50=true;
          this.surveyServ.Normaclosesurvey(this.idProducto_tmp,0,this.idEmpresa).subscribe((data:backInter.surveyprogress) => {
            console.log("Porcentaje más de 50");
            this.dataTmp1=data.avance;
            this.porcentaje1=this.dataTmp1.porcentaje;
          });
        }
      }else{
        this.hasNorma=false;
        this.hasFocus=false;
      }

      this.mostrarTabla=false;
      this.SurveyId=idSurvey;
      this.currentStep=1;
      console.log('nombreProducto',nombreProducto);

      this.translateSrv.get(nombreProducto).subscribe((res: string) => { nombreProducto = res; });
      this.product_name = nombreProducto+" "+anio;
      this.nombreProductoSel = nombre;

      this.mostrarSeccion=true;
console.log('mostrarSeccion+++++++++++++',this.mostrarSeccion);

    if(tipoProductoId!=52){
      this.getBanderaUpdateFechaCierre();
      this.obtieneToken();
    }
      let instituto = parseInt(localStorage.getItem('instituto_id'));
      if(this.hasNorma){
        this.cargando=true;
        if(this.SurveyIdMenos || this.SurveyIdMas){
          this.noEncuesta=false;
        }else{
          this.noEncuesta=true;
          this.cargando=true;
        }
        localStorage.setItem('tipoProducto','5');
      }else if(this.hasFocus){
        console.log("entro a focus");
        let dataInfo:any = {productoId: this.idProducto_tmp}
         this.surveyServ.getMostrarEncuestas(dataInfo,this.idEmpresa).subscribe((respuesta:any) => {
           console.log(respuesta);
           let idFocus:any;
           for(let i=0; i < respuesta.data.length; i++){
             if(respuesta.data[i].productoId == this.idProducto_tmp){
                idFocus=respuesta.data[i]._id;
                this.idFocus_config=respuesta.data[i].idSurveyConfiguration;
                this.tokenConfig=respuesta.data[i].tokenConfig;
               break;
             }
           }
            idFocus=''+idFocus;
            this.idFocus=idFocus;
            if(this.idFocus_config){
              this.noEncuesta=false;
              this.disableButton=false;
              this.mostrarTabla=true;
              this.getFechasFocus();
            }

            this.cargando=true;
         }, error => {
           console.log(error);
         });

      }else if(this.SurveyId){
        if(tipoproducto){
          this.tipoproducto=tipoproducto;
        }else{
          this.tipoproducto=0;
        }
        this.plantilla=plantilla;
        this.noEncuesta=false;
        this.urlEncuestas();
        this.mostrarTabla=true;
        this.cargando=true;

      }else{
        this.noEncuesta=true;
        this.cargando=true;
      }
    }else{
      this.mostrarSeccion=true;
      console.log('mostrarSeccion+++++++++++++',this.mostrarSeccion);
      this.noEncuesta=true;
      this.cargando=true;
    }


  }
  arregloOrdenado:any[]=[];
  cargandoTablaFiltros:boolean=true;
  obtenerUser(event,nombre?){
    console.log("Busqueda "+this.busqueda);

    console.log(event)
    let instituto = parseInt(localStorage.getItem('instituto_id'));
    if(this.hasNorma){
      if(this.busqueda.length > 0){
        console.log('entro norma');

        this.surveyServ.desColaboradoresV2(this.SurveyIdMenos,this.SurveyIdMas,4,instituto,this.busqueda).subscribe( (data: any) => {
          console.log(data);
          this.data_users(data,0);
        });
      }else{
        this.dataSource_nuevo=null;
      }
      // this.surveyServ.desColaboradoresV2(this.SurveyIdMenos,this.SurveyIdMas,4,instituto,this.busqueda).subscribe( (data: any) => {
      //   console.log(data);
      //   this.data_users(data,0);
      // });
    }else if(this.hasFocus){
      if(this.busqueda.length > 0){
        this.surveyServ.desColaboradoresV2(this.idFocus_config,0,1,instituto,this.busqueda).subscribe( (data : any) => {
          console.log("Data focus");
          console.log(data);
          this.data_users(data,0);
        }, error  => {
          console.log("error");
        });
      }else{
        this.dataSource_nuevo=null;
      }
    }else{
      if(this.busqueda.length > 0){
        this.surveyServ.desColaboradoresV2(this.SurveyId,0,1,instituto,this.busqueda).subscribe( (data : any) => {
          console.log("Data genrricos version2, certificar y medir");
          console.log(data);
          this.data_users(data,0);
        }, error  => {
          console.log("error");
        });
      }else{
        this.dataSource_nuevo=null;
      }

    }
  }

  show1000(){
    let instituto = parseInt(localStorage.getItem('instituto_id'));
    if(this.hasNorma){
      console.log('entro caso norma');
      console.log('this.SurveyId',this.SurveyId);
      this.surveyServ.desColaboradores(this.SurveyIdMenos,this.SurveyIdMas,4,instituto).subscribe( (data: backInter.resultExcel) => {
        console.log(data);
        this.data_users(data,0);
      });
    }else{
      this.surveyServ.desColaboradores(this.SurveyId,0,3,instituto).subscribe( (data: backInter.resultExcel) => {
        console.log(data);
        this.data_users(data,0);
      });
    }
  }

  data_users(data,idstatus){
    console.log(data);

    let label1='AVANCES.ETIQUETAS.ETIQUETAS';
    let label2='AVANCES.ETIQUETAS.OF';
    this.translateSrv.get(label1).subscribe((res: string) => { label1= res; });
    this.translateSrv.get(label2).subscribe((res: string) => { label2= res; });
    this.listaUsuarios=data.result;
    this.arregloOrdenado=this.listaUsuarios;
    this.arregloOrdenado.sort((a,b) => a.name.localeCompare(b.name));
    this.listaUsuarios=this.arregloOrdenado;
    if(idstatus > 0){
      this.array_lista=[];
      for(let i=0; i< this.listaUsuarios.length; i++){
        if(this.listaUsuarios[i].id_status == idstatus){
          this.array_lista.push(this.listaUsuarios[i]);
        }
      }
      this.listaUsuarios = this.array_lista;
    }

      this.dataSource_nuevo = new MatTableDataSource(this.listaUsuarios); // Filtro
      this.dataSource_nuevo.paginator = this.paginator;
      this.dataSource_nuevo.sort = this.sort;
      setTimeout(() => this.dataSource_nuevo.paginator=this.paginator);
      setTimeout(() => this.paginator._intl.itemsPerPageLabel=label1);
      setTimeout(() => this.paginator._intl.getRangeLabel=(page: number, pageSize: number, length: number) => { if (length == 0 || pageSize == 0)
        { return `0 ${label2} ${length}`; } length = Math.max(length, 0); const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} – ${endIndex} ${label2} ${length}`; });
        this.cargandoTablaFiltros= false;
        this.dataSource_nuevo.filterPredicate = (data, filterValue: string)  => {
          const accumulator = (currentTerm, key) => {
            return key === 'doctores' ? currentTerm : currentTerm + data[key];
          };
          const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
          // Transform the filterValue by converting it to lowercase and removing whitespace.
          const transformedFilter = filterValue.trim().toLowerCase();
          return dataStr.indexOf(transformedFilter) !== -1;
        };
        this.mostrarTabla=true;
        this.cargando=true;
        if(this.listaUsuarios.length == 0){
          this.Nousers=true;
        }else{
          this.Nousers=false;

        }

  }
  urlEncuesta:any; // Variables para botón de abrir encuesta
  showUrl:boolean=false; //Variables para botón de abrir encuesta
  fechaCierre_Avance:any;
  porcentaje:any;
  flagCierre:any;
  diasRestantes:any;
  showMedir:boolean=false;

  urlEncuestas(){
    this.showUrl=false;
  if (this.nombreProducto=='Certify') {
    if (this.tipoProductoSeleccionado==40) {
      localStorage.setItem('tipoProducto','c1');
    }else if (this.tipoProductoSeleccionado==41) {
        localStorage.setItem('tipoProducto','m7');
    }else if (this.tipoProductoSeleccionado==42) {
      localStorage.setItem('tipoProducto','p1');
    }else if (this.tipoProductoSeleccionado==43) {
      localStorage.setItem('tipoProducto','f1');
    }else{
      localStorage.setItem('tipoProducto','1');
    }

  }else if (this.nombreProducto=='Certify3') {
      localStorage.setItem('tipoProducto','c3');
  }else if (this.nombreProducto=='Focus 1') {
      localStorage.setItem('tipoProducto','f1');
  }else if (this.nombreProducto=='Measure3') {
      localStorage.setItem('tipoProducto','m7');
  }else if (this.nombreProducto=='Pulse3') {
      localStorage.setItem('tipoProducto','p1');
  }
  console.log('this.nombreProducto+++++++++++++++++',this.nombreProducto);

    switch(this.nombreProducto){
      case 'Certify': case 'Certify3': case 'Focus 1': case 'Measure3 ': case 'Pulse3':
        this.validarEncuesta();
        this.getClaveConteo();
        this.tipoProductoClaveConteos=1;
        localStorage.setItem('fechaProducto',this.fechaProducto);
        let data={
          productoId: this.idProducto_tmp
        };
        this.encuestaService.getPilotoDataEncuesta_estatus(data,this.idEmpresa).subscribe((data: any) => {
          console.log("getPilotoData:",data);
          if(data.message = 'Success'){
            this.urlEncuesta=data.piloto.url;
            this.showUrl=true;
          }
        });
        let dataAvance={
          productoId : this.idProducto_tmp
        };
        var moment = require('moment');
        console.log(dataAvance);
        console.log(this.idEmpresa);
        this.encuestaService.getAvanceEncuesta(dataAvance,this.idEmpresa).subscribe(response => {
          console.log(response);
          // this.fechaLanzamiento=response['fechaLanzamiento'];
          // this.disableButton=false;
          let fechaActual= moment();
          let  now = new Date();
          let fechaDeLanzamiento=new Date(response['fechaLanzamiento']);
          /*if(now<fechaDeLanzamiento){
            console.log("Entro menor fecha");
            this.bloquearBotonReminder=true;
            localStorage.setItem("bloquear_btn","true");
          }else{
            console.log("Entro  fecha");
          }*/
          if(response['message'] == 'Success'){
            this.fechaCierre_Avance=response['fechaCierre'];
            this.porcentaje = +response['avance']['porcentaje'];
            if(response['completoCertificar'] == '2'){
              this.flagCierre = true;
            }
          }
          if (this.sinProrrogas) {

            let fechaCierreProrroga= moment(this.prorrogasGuardas);
            if(fechaActual.isAfter(fechaCierreProrroga)){
              this.diasRestantes=0;
              console.log(this.diasRestantes);
             }else{
              this.diasRestantes=fechaCierreProrroga.diff(fechaActual,'days');
              console.log(this.diasRestantes);
            }

            this.bloquearEnvias(fechaActual,fechaCierreProrroga);
          }else{
          let fechaCierre= moment(this.fechaCierre);
          this.bloquearEnvias(fechaActual,this.fechaCierre);
          if(fechaActual.isAfter(fechaCierre)){
            this.diasRestantes=0;
            console.log(this.diasRestantes);
           }else{
            this.diasRestantes=fechaCierre.diff(fechaActual,'days');
            console.log(this.diasRestantes);
          }
        }
        }, error => {
          console.log(error);
        });
      break;
      case 'NAV.MEDIR.SUBPRODUCTOS.0':
        this.activeSurvey=true;
        this.getUrl_medires();
        this.getAvancesMedir();
        this.getClaveConteo();
        localStorage.setItem('tipoProducto','2');
        this.showMedir=true;
        this.tipoProductoClaveConteos=2;
      break;
      case 'NAV.MEDIR.SUBPRODUCTOS.1':
      localStorage.setItem('tipoProducto','m1'); this.activeSurvey=true; this.getUrl_medires(); this.getAvancesMedir(); this.showMedir=true;
      this.getClaveConteo();
      this.tipoProductoClaveConteos=2;
      break;
      case 'NAV.MEDIR.SUBPRODUCTOS.2': this.activeSurvey=true; localStorage.setItem('tipoProducto','m2'); this.getUrl_medires(); this.getAvancesMedir(); this.showMedir=true; this.getClaveConteo(); this.tipoProductoClaveConteos=2;break;
      case 'NAV.MEDIR.SUBPRODUCTOS.3': this.activeSurvey=true; localStorage.setItem('tipoProducto','m3'); this.getUrl_medires(); this.getAvancesMedir(); this.showMedir=true; this.getClaveConteo(); this.tipoProductoClaveConteos=2;break;
      case 'NAV.MEDIR.SUBPRODUCTOS.4': this.activeSurvey=true; localStorage.setItem('tipoProducto','m4'); this.getUrl_medires(); this.getAvancesMedir(); this.showMedir=true; this.getClaveConteo(); this.tipoProductoClaveConteos=2;break;
      case 'NAV.MEDIR.SUBPRODUCTOS.5': this.activeSurvey=true; localStorage.setItem('tipoProducto','m5'); this.getUrl_medires(); this.getAvancesMedir(); this.showMedir=true; this.getClaveConteo(); this.tipoProductoClaveConteos=2;break;
      case 'NAV.MEDIR.SUBPRODUCTOS.6': this.activeSurvey=true; localStorage.setItem('tipoProducto','m6'); this.getUrl_medires(); this.getAvancesMedir(); this.showMedir=true; this.getClaveConteo(); this.tipoProductoClaveConteos=2;break;
      case 'NAV.PULSE.TITULO':
      //this.activeSurvey=true;
      this.getClaveConteoPulse();
      this.tipoProductoClaveConteos=4;
      var moment = require('moment');
      this.validarEncuesta();
      localStorage.setItem('tipoProducto','3');
      let dataPulse={productoId: this.idProducto_tmp};
      this.surveyServ.getPilotoData_Pulse(dataPulse,this.idEmpresa).subscribe((response: any )=> {
        console.log(response);
        if(response.message = 'Success'){
          this.urlEncuesta=response.data[0].urlShorter;
          this.showUrl=true;
          this.cierreService.getFechasProgramacionPulse_status(this.idProducto_tmp,this.idEmpresa).subscribe((respuesta: any)=>{
            console.log(respuesta);
            this.fechaLanzamiento=respuesta.data[0].fechaLanzamiento;
            console.log('this.fechaLanzamiento',this.fechaLanzamiento);

            this.fechaCierre=respuesta.data[0].fechaCierre;
            let fechaDeCierre=respuesta.data[0].fechaCierre;
            let  now = new Date();
            console.log("fechaActual",now);
            let fechaDeLanzamiento=new Date(this.fechaLanzamiento);
            console.log("fechaLanzamientoActual",fechaDeLanzamiento);

            if(now>fechaDeLanzamiento){
              this.btnProrroga=true;
              console.log('btnProrroga',this.btnProrroga);
              this.filtroLanzamiento = (d: Date | null): boolean => {
                let fechaMinima: any;
                return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
              };
              this.fechaValueProrroga=now;
              console.log("fecha actual es mayor a la de lanzamiento");
            }else{
              this.fechaValueProrroga=fechaDeLanzamiento;
              this.bloquearBotonReminder=true;
              localStorage.setItem("bloquear_btn","true");
              console.log("fecha actual no es mayor a la de lanzamiento");
              this.filtroLanzamiento = (d: Date | null): boolean => {
                let fechaMinima: any;
                return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
              };
            }
            this.disableButton=false;
            this.getAvancesPulse();
          });
        }
      }, error => {
        console.log(error);
      });



      break;
      case 'express':
      console.log('no hace nada de nada por ahora ');

    }
  }
  typeSurvey1:boolean;
  typeSurvey2:boolean;


  getUrl_medires(){
    localStorage.setItem('fechaProducto',this.fechaProducto);
    let dataMedir={
      productoId : this.idProducto_tmp
    };
    this.surveyServ.getPilotoData_medir(dataMedir,this.idEmpresa).subscribe( (response: any)=>{
      if(response.message = 'Success'){
        this.urlEncuesta=response.piloto.url;
        this.showUrl=true;

      }
    });
  }
  getAvancesMedir(){
    var moment = require('moment');
    let data={
      productoId : this.idProducto_tmp
    };

      this.surveyServ.getAvanceEncuestaMedir(data,this.idEmpresa)
        .subscribe(response => {
          console.log(response);
          this.fechaLanzamiento=response['fechaLanzamiento'];
          let  now = new Date();
          let fechaDeLanzamiento=new Date(this.fechaLanzamiento);
          if(now<fechaDeLanzamiento){
            this.bloquearBotonReminder=true;
            localStorage.setItem("bloquear_btn","true");
          }

          this.disableButton=false;
          if(response['message'] == 'Success'){
            this.fechaCierre=response['fechaCierre'];
            this.porcentaje = +response['avance']['porcentaje'];
          }
          let fechaActual= moment();
          let fechaCierre= moment(this.fechaCierre);
          if(fechaActual.isAfter(fechaCierre)){
            this.diasRestantes=0;
            console.log(this.diasRestantes);
          }else{
            this.diasRestantes=fechaCierre.diff(fechaActual,'days');
            console.log(this.diasRestantes);
          }
        }, error => {
          console.log("Estatus cierre encuesta");
          console.log(error);
        });
  }

  getAvancesPulse(){
    this.cierreService.getProgressEncPulse_status(this.idProducto_tmp,this.idEmpresa).subscribe((resultado: any)=>{
      console.log(resultado);
      if(resultado.success){
        var moment = require('moment');
        this.porcentaje=resultado.data[0].porcentaje;
        let fechaActual= moment();
        let fechaCierre= moment(this.fechaCierre);
        if(fechaActual.isAfter(fechaCierre)){
          this.diasRestantes=0;
        }else{
          this.diasRestantes=fechaCierre.diff(fechaActual,'days');
        }
      }

    });
  }
  typeSurvey(type){
    console.log("Type  survey"+type);
    // 1 es menos de 50 y 2 más de 50
    if(type==1){
      localStorage.setItem('surveytype',"1");
    }else{
      localStorage.setItem('surveytype',"0");

    }
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource_nuevo.filter = filterValue.trim().toLowerCase();
  }


  DialogDescargar_encuesta(): void {

    console.log("Codigo del proyecto "+this.codigoDeProyecto);
    let dataModal: any;
    console.log('tipoPrdocuto',this.tipoproducto);

    const dialogRef = this.dialog.open(DescargaEncuestaComponent, {
      width: '500px', height: '250px',
      data: {
        fecha:this.fechaProducto,
        idProducto:this.idProducto_tmp,
        tipoProducto:this.tipoproducto,
        plantilla:this.plantilla,
        idEmpresa:this.idEmpresa,
        nombreEmpresa:this.nombreEmpresa,
        codigoDeProyecto:this.codigoDeProyecto,
        productoId:this.tipoProductoSeleccionado,
        instituto:parseInt(localStorage.getItem('instituto_id')),
      }


    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialog(idsurvey?): void {
    let dataModal: any;
    const dialogRef = this.dialog.open(SurveyDialog, {
      width: '1500px', height: '450px',
      data: {
        SurveyId:this.SurveyId,
        surveyKey:idsurvey,
        idEmpresa:this.idEmpresa,
        idSurveyMas: this.SurveyIdMas,
        idSurveyMenos: this.SurveyIdMenos,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogFocus(idsurvey?): void {
    let dataModal: any;
    const dialogRef = this.dialog.open(SurveyDialog, {
      width: '1500px', height: '450px',
      data: {
        SurveyId:this.idFocus_config,
        surveyKey:idsurvey,
        idEmpresa:this.idEmpresa,
        idSurveyMas: this.SurveyIdMas,
        idSurveyMenos: this.SurveyIdMenos,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  openDialogSurvey(): void {
    let dataModal: any;
    const dialogRef = this.dialogSurvey.open(NuevoColaboradorComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: {
        SurveyId:this.SurveyId,
        idEmpresa:this.idEmpresa,
        idSurveyMas: this.SurveyIdMas,
        idSurveyMenos: this.SurveyIdMenos,
        idProducto: this.idProducto_tmp,
        nombreProductoSel: this.nombreProductoSel
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.obtenerData(
          this.ultimoProducto.nombreProducto,
          this.ultimoProducto.anio,
          this.ultimoProducto.productoId,
          this.ultimoProducto.elem,
          this.ultimoProducto.idSurvey,
          this.ultimoProducto.idSurveyMenos,
          this.ultimoProducto.idSurveyMas,
          this.ultimoProducto.nombre,
          this.ultimoProducto.nombreSecundario
        );
      }
    });
  }

  openDialogAcciones(datosColab: any): void {
    console.log('datosColab:::',datosColab);

    let dataModal: any;
    const dialogRef = this.dialogSurvey.open(AccionesComponent, {
      width: '800px', height: '390px',
      // width: '80%',
      // height: '90%',
      data: {

        SurveyId:this.SurveyId,
        idEmpresa:this.idEmpresa,
        idSurveyMas: this.SurveyIdMas,
        idSurveyMenos: this.SurveyIdMenos,
        idProducto: this.idProducto_tmp,
        nombreProductoSel: this.nombreProductoSel,
        datosColab
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log("result1:",result);
      // if(result){
        this.obtenerData(
          this.ultimoProducto.nombreProducto,
          this.ultimoProducto.anio,
          this.ultimoProducto.productoId,
          this.ultimoProducto.elem,
          this.ultimoProducto.idSurvey,
          this.ultimoProducto.idSurveyMenos,
          this.ultimoProducto.idSurveyMas,
          this.ultimoProducto.nombre,
          this.ultimoProducto.nombreSecundario
        );
      // }
    });
  }

  openDialogAccionesEmail(email,name,tipo,tipoProducto,estado?){
    let dataModal: any;
    let instituto = parseInt(localStorage.getItem('instituto_id'));
    let encuestaId;
    if(this.hasFocus){
      //encuestaId=this.idFocus;
      encuestaId=this.idFocus;
    }else{
      encuestaId=this.SurveyId;
    }
    const dialogRef = this.dialog.open(EmailAction_Dialog, {
      width: '780px', height: '390px',
      data: {
        email:email,
        username:name,
        tipo:tipo,
        idEmpresa:this.idEmpresa,
        idProducto:this.idProducto_tmp,
        encuestaId: encuestaId,
        tipoProducto: tipoProducto,
        tokenConfig:this.tokenConfig,
        instituto: instituto,
        fecha:this.fechaProducto,
        estaadoEncuesta:estado,
        nombreProducto:this.nombreProductoSel,
        fechaLanzamiento:this.fechaLanzamiento,
        cerrarEncuesta: this.encuesta_cerrada
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  listaUsuarios: any[] = [];
  btnDescargar(){
    let statusSurvey1="AVANCES.ENCUESTA.DESCARGAR";
    this.translateSrv.get(statusSurvey1).subscribe((res: string) => { statusSurvey1 = res; });
    this.traduceTextosTS();
    Swal.fire({
      title: statusSurvey1,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    this.traduceTextosTS();
    let instituto = parseInt(localStorage.getItem('instituto_id'));
    if(this.hasNorma){
      this.surveyServ.desColaboradores(this.SurveyIdMenos,this.SurveyIdMas,2,instituto).subscribe( (data: backInter.resultExcel) => {
        this.listaUsuarios=data.result;
        localStorage.setItem('tipoProducto','5');
        this.cambiarEstatus(data.result);
      });
    }else if(this.hasFocus){
      this.surveyServ.desColaboradores(this.idFocus_config,0,1,instituto).subscribe( (data: backInter.resultExcel) => {
        console.log("Resultados focus");
        console.log(data);
        localStorage.setItem('tipoProducto','4');
        this.listaUsuarios=data.result;
        this.cambiarEstatus(data.result);
      });

    }else{
      let contador=0;
      this.surveyServ.desColaboradores(this.SurveyId,0,1,instituto).subscribe( (data: backInter.resultExcel) => {
        console.log("Resultados");
        console.log(data);
        this.listaUsuarios=data.result;
        this.cambiarEstatus(data.result);

      });
    }

  }

  cambiarEstatus(Array){
    let contador=0;
    console.log(Array);
    Array.forEach(producto => {
      if(this.hasNorma){
        //this.listaUsuarios[contador].email=this.resultadosUsuario[contador].email;
        //this.listaUsuarios[contador].name=this.resultadosUsuario[contador].fullName;
        //this.listaUsuarios[contador].name="N/A";
      }else{
        //this.listaUsuarios[contador].email=Array[contador].email;
      }
      if(this.listaUsuarios[contador].start_date == null){
        this.listaUsuarios[contador].start_date="N/A";
      }
      if(this.listaUsuarios[contador].end_date == null){
        this.listaUsuarios[contador].end_date="N/A";
      }
      if(producto.id_status){
        switch (producto.id_status){
          case 1:
            let statusSurvey1="AVANCES.TITULOS.ESTADOS_ENC.ESTADO1";
            this.translateSrv.get(statusSurvey1).subscribe((res: string) => { statusSurvey1 = res; });
            this.listaUsuarios[contador].id_status=statusSurvey1;
          break;
          case 2:
            let statusSurvey2="AVANCES.TITULOS.ESTADOS_ENC.ESTADO1";
            this.translateSrv.get(statusSurvey2).subscribe((res: string) => { statusSurvey2 = res; });
            this.listaUsuarios[contador].id_status=statusSurvey2;
          break;
          case 3:
            let statusSurvey3="AVANCES.TITULOS.ESTADOS_ENC.ESTADO3";
            this.translateSrv.get(statusSurvey3).subscribe((res: string) => { statusSurvey3 = res; });
            this.listaUsuarios[contador].id_status=statusSurvey3;
          break;
          case 4:
            let statusSurvey4="AVANCES.TITULOS.ESTADOS_ENC.ESTADO4";
            this.translateSrv.get(statusSurvey4).subscribe((res: string) => { statusSurvey4 = res; });
            this.listaUsuarios[contador].id_status=statusSurvey4;
          break;
        }

      }else{
        this.listaUsuarios[contador].id_status="N/A";
      }

      contador++;
    });

    this.descargaExcel(this.listaUsuarios);
  }
  idiomaActual:string;

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
    console.log(this.mensajesTraducirTS);
    this.idiomaActual = this.translateSrv.currentLang;
  }

  descargaExcel(Array){
    Swal.showLoading()
    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: this.product_name+' '+this.mensajesTraducirTS.columna6,
      Subject: this.mensajesTraducirTS.columna6,
      Author: 'Autor',
      CreatedDate: new Date()
    };
    wb.SheetNames.push('hoja');
    var ws_data = [];
    let nombresColumnas:string[] = [];
    //this.mensajesTraducirKeys[iter]
    backInter.CLAVES_COLUMNASPRODUCTOS.forEach( (nombre) => {
      switch(nombre){
        case 'name': nombresColumnas.push(this.mensajesTraducirTS.columna4); break;
        case 'email': nombresColumnas.push(this.mensajesTraducirTS.columna1); break
        case 'id_status': nombresColumnas.push(this.mensajesTraducirTS.columna3); break;
        case 'start_date': nombresColumnas.push(this.mensajesTraducirTS.columna5); break;
        case 'end_date': nombresColumnas.push(this.mensajesTraducirTS.columna2); break;
      }
    });
    //console.log("Colaboradores")
    ws_data.push(nombresColumnas);
      Array.forEach( (colaborador) => {
        let datosColaboradores:any[] = [];
        // for(let i=0;i<nombresColumnas.length;i++){
        backInter.CLAVES_COLUMNASPRODUCTOS.forEach( (nombre) => {
          switch(nombre){
            case 'name': datosColaboradores.push(colaborador.name); break;
            case 'email': datosColaboradores.push(colaborador.email); break;
            case 'id_status': datosColaboradores.push(colaborador.id_status); break;
            case 'start_date': datosColaboradores.push(colaborador.start_date); break;
            case 'end_date': datosColaboradores.push(colaborador.end_date); break;
          }
        });
        ws_data.push(datosColaboradores);
        console.log(ws_data);
      });
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets['hoja'] = ws;
      var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
      var view = new Uint8Array(buf);  //create uint8array as viewer
      for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
      saveAs(new Blob([buf],{type:"application/octet-stream"}),this.product_name+' '+this.mensajesTraducirTS.columna6+' - '+this.nombreEmpresa+'.xlsx');
      Swal.close();
  }

  obtieneToken(){

  this.datosProd.productosCertificar.forEach(producto => {
  if (producto.idCertificar==this.idProducto_tmp) {
  console.log('si coincide en certificar 2');
  this.token=producto.tokenConfig;
  this.añoProducto=producto.fechaCertificar;
  this.getFechaLanzamiento(this.añoProducto);
  console.log(this.token);
  this.getStatusEncuesta(this.token);
  }
  });

  this.datosProd.productosMedir.forEach(producto => {
  if (producto.idMedir==this.idProducto_tmp) {
  console.log('si coincide en medir 1');
  this.token=producto.tokenConfig;
  this.añoProducto=producto.fechaMedir;
  console.log(this.token);
  this.getStatusEncuesta(this.token);
  }
  });

  this.datosProd.productosMedir2.forEach(producto => {
  if (producto.idProducto==this.idProducto_tmp) {
  console.log('si coincide en medir 2');
  this.token=producto.tokenConfig;
  this.añoProducto=producto.fechaProducto;
  console.log(this.token);
  this.getStatusEncuesta(this.token);
  }
  });


  this.datosProd.productosPulseCheck.forEach(producto => {
  if (producto.idPulseCheck==this.idProducto_tmp) {
  console.log('si coincide en PulseCheck');
  this.token=producto.tokenConfig;
  this.añoProducto=producto.idPulseCheck;
  console.log(this.token);
  this.getStatusEncuesta(this.token);
  }
  });

  this.datosProd.productosNorma35.forEach(producto => {
    if (producto.idNorma35==this.idProducto_tmp) {
    console.log('si coincide en norma');
    //this.token=producto.tokenConfig;
    this.añoProducto=producto.fechaNorma35;
    console.log(this.token);
    //this.getFechaLanzamientoNorma(this.añoProducto);
    //this.getStatusEncuesta(this.token);
    }
    });


  }

///funciones para crear prorrogas
  saveActualizarFechaCierreProrroga(fecha:any){
    this.fechaProrrogaBackUtc0=fecha;
    console.log("fecha",fecha);
    let warningText='AVANCES.WARNING-FECHA-GUARDAR';
    let successText='AVANCES.SUCCESS-PRORROGA';
    let aceptarText='AVANCES.BOTONES-MODALES.ACEPTAR';
    let cancelarText='AVANCES.BOTONES-MODALES.CANCELAR';
    let okText='AVANCES.BOTONES-MODALES.OK';
    this.translateSrv.get(warningText).subscribe((res: string) => { warningText = res; });
    this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
    this.translateSrv.get(aceptarText).subscribe((res: string) => { aceptarText = res; });
    this.translateSrv.get(cancelarText).subscribe((res: string) => { cancelarText = res; });
    this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });

    let moment = require('moment');
    let fechaActual=fecha
    console.log(fechaActual);
    this.dialogFechaProrroga(this.idProducto_tmp,this.idEmpresa,this.fechaProrrogaBackUtc0,this.token,);

  }

//////// funcion que obtiene fecha lanzamiento certificar 2.0
  disableButton:boolean=true;
  getFechaLanzamiento(datos){
    let data:any = {
      productoId:this.idProducto_tmp
    };
    this.sheduleService.getFechaLanzamientoStatusEncuesta(this.idEmpresa,data).subscribe((respuesta:any) => {
      console.log("respGetLanza",respuesta);
      if (respuesta.message=="200") {
        this.fechaLanzamiento=respuesta.fechaLanzamiento;
        let moment = require('moment'); //FOrmato más 3
        this.fechaCierre=respuesta.fechaCierre;
        let now= new Date();
        let fechaDeLanzamiento=moment(this.fechaLanzamiento);
        let fechaDeCierre=moment(respuesta.fechaCierre);
        if(now>fechaDeLanzamiento){
          this.btnProrroga=true;
          console.log("this.btnProrroga",this.btnProrroga);

          this.fechaValueProrroga=now;
          console.log("fecha actual es mayor a la de lanzamiento");
          this.filtroLanzamiento = (d: Date | null): boolean => {
            let fechaMinima: any;
            return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
          };

        }else{
          this.fechaValueProrroga=fechaDeLanzamiento;
          this.bloquearBotonReminder=true;
          localStorage.setItem("bloquear_btn","true");
          console.log("fecha actual no es mayor a la de lanzamiento");
          this.filtroLanzamiento = (d: Date | null): boolean => {
            let fechaMinima: any;
            return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
          };
        }
        this.disableButton=false;
      }else{
        console.log("nada");

      }

    });
  }
  acomodarFecha(date){
    const hora_valor = 360000;
    var timestamp1 = new Date(date).getTime();
    var fianaltotal;
    switch(localStorage.getItem('instituto_id')){
      case '1': fianaltotal= (timestamp1 -(hora_valor * 5 ) ); break;
      case '2': fianaltotal= (timestamp1 -(hora_valor * 5 ) ); break;
      case '3': fianaltotal= (timestamp1 +(hora_valor * 8 ) ); break;
      case '4': fianaltotal= (timestamp1 +(hora_valor * 8 ) ); break;
      case '5': fianaltotal= (timestamp1 +(hora_valor * 3 ) ); break;
      case '6': fianaltotal= (timestamp1 +(hora_valor * 8 ) ); break;
      case '11':fianaltotal= (timestamp1 -(hora_valor * 3 ) ); break;
      case '15':fianaltotal= (timestamp1 +(hora_valor * 1 ) ); break;
    }
    var date_final = new Date(fianaltotal);
    return date_final;

  }
  arrayRemainders:any;
  getFechaLanzamientoNorma(datos){
    let dataReg={
      'fechaNorma35' : datos
    };
    console.log(dataReg);
    this.programacionService35.getFechaLanzamiento35_req(dataReg,this.idEmpresa)
    .subscribe((response:any) => {
      console.log(response);
      if(response.message == "200"){
        let  now = new Date();
        console.log("fechaActual",now);
        let fechaDeLanzamiento=new Date(response.fechaLanzamiento);
        if (now>fechaDeLanzamiento) {
          this.btnProrroga=true;
        }else{
          this.btnProrroga=false;
        }
        console.log("Entro fecha lanzamiento norma");
        this.fechaLanzamiento = response.fechaLanzamiento;
        this.fechaCierre = response.fechaCierre;
        this.disableButton=false;
        let fechaActual= moment();
        let fechaCierreProrroga= moment(this.fechaCierre);
          if(fechaActual.isAfter(fechaCierreProrroga)){
            this.diasRestantes=0;
          }else{
            this.diasRestantes=fechaCierreProrroga.diff(fechaActual,'days');
          }
      }

    }, error => {
      console.log(error);
    });
  }

  getFechasFocus(){
    this.surveyServ.getAvanceEncuestaFocus(this.idFocus).subscribe((response:any)=>{
      if(response.message=="Success"){
        this.fechaLanzamiento=response.fechaInicio;
        this.fechaCierre=response.fechaCierre;
        this.porcentaje=response.avance.porcentaje
      }
    });
  }

//////// funcion que obtiene fecha lanzamiento PulseCheck
  getFechaLanzamientoProductosPulsecheck(datos){
    console.log("entro lafuncion del get de PulseCheck");
    let data:any = {
      productoId:datos
    };
    console.log(data);
    this.programacionService.getFechaLanzamientoStatusEncuestaPulsecheck(this.idEmpresa,data).subscribe((respuesta:any) => {
      console.log("respGetLanza",respuesta);
      if (respuesta.message=="success") {
        this.fechaLanzamiento=respuesta.data[0].fechaLanzamiento;
        this.fechaCierre=respuesta.data[0].fechaCierre;
        let  now = moment().format('MM/DD/YYYY');
        console.log("fechaActual",now);
        let fechaDeLanzamiento=moment(this.fechaLanzamiento).format('MM/DD/YYYY');
        let fechaDeCierre=moment(this.fechaLanzamiento).format('MM/DD/YYYY');
        console.log("fechaLanzamientoActual",fechaDeLanzamiento);
        if(now>fechaDeLanzamiento){
          this.btnProrroga=true;
          console.log("this.btnProrroga",this.btnProrroga);

          this.fechaValueProrroga=now;
          console.log("fecha actual es mayor a la de lanzamiento");
          this.filtroLanzamiento = (d: Date | null): boolean => {
            let fechaMinima: any;
            return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
          };
        }else{
          this.fechaValueProrroga=fechaDeLanzamiento;
          this.bloquearBotonReminder=true;
          localStorage.setItem("bloquear_btn","true");
          console.log("fecha actual no es mayor a la de lanzamiento");
          this.filtroLanzamiento = (d: Date | null): boolean => {
            let fechaMinima: any;
            return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
          };
        }
      }else{
        console.log("nada");
      }
    });
  }

  getProrrogasFechasCierre(datos){
    console.log(datos);
    this.surveyServ.getProrrogasFechaCierre(datos).subscribe( (data: any) => {
      console.log(data);
      if(data.result.length>0){
        this.prorrogasGuardas=data.result[0].fecha;
        this.filtroCierreProrroga = (d: Date | null): boolean => {
          let fechaMinima: any;
          return moment(d || new Date()).format('MM/DD/YYYY') > moment(this.prorrogasGuardas).format('MM/DD/YYYY')
        };
        this.sinProrrogas=true;
        let fechaCerrar= new Date();
        console.log("Fecha cerrar "+fechaCerrar);
        this.bloquearEnvias(fechaCerrar,this.prorrogasGuardas);
      }else{
        this.sinProrrogas=false;
        let fechaCerrar= new Date();
        this.bloquearEnvias(fechaCerrar,this.fechaCierre);
      }
    });
  }

  bloquearEnvias(fechaActual,fechaCierre){
    var timestamp1 = new Date(fechaActual).getTime();
    var timestamp2 = new Date(fechaCierre).getTime();
    if(!this.encuesta_cerrada){ // Si la encuesta esta cerrada no debe entrar a estas condiciones
      if(timestamp1>timestamp2){
        localStorage.setItem("bloquear_btn","true");
        this.encuesta_cerrada=true;
      }else{
        localStorage.setItem("bloquear_btn","false");
        this.encuesta_cerrada=false;
      }
    }


    console.log("Encuesta "+this.encuesta_cerrada);
  }

  getBanderaUpdateFechaCierre(){
  console.log("producto id ",this.idProducto_tmp);
  console.log("producto id ",this.idEmpresa);
    this.programacionService.getStatusBanderaProrroga(this.idEmpresa,this.idProducto_tmp).subscribe((respuesta:any) => {
      console.log("respuesta:",respuesta);
      this.permisoProrroga=respuesta.activarProrroga;
    });
  }

  actualizaCerrarEncuesta(status:number){
    console.log(status);
    let warningText='AVANCES.WARNING-CIERRE-ENCUESTA';
    let successText='AVANCES.SUCCESS-CIERRE';
    let aceptarText='AVANCES.BOTONES-MODALES.ACEPTAR';
    let cancelarText='AVANCES.BOTONES-MODALES.CANCELAR';
    let okText='AVANCES.BOTONES-MODALES.OK';
    this.translateSrv.get(warningText).subscribe((res: string) => { warningText = res; });
    this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
    this.translateSrv.get(aceptarText).subscribe((res: string) => { aceptarText = res; });
    this.translateSrv.get(cancelarText).subscribe((res: string) => { cancelarText = res; });
    this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
    Swal.fire({
      title: warningText,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: aceptarText,
      cancelButtonText: cancelarText
    }).then((result) => {
      if (result.value) {
        // datos.token=this.token;
        let datos:any={}
        datos.status=status;
        this.surveyServ.actualizaEstatusCierreEncuesta(this.idEmpresa,this.idProducto_tmp,datos).subscribe((resul: any)=>{
          console.log(resul);
          Swal.fire({
            icon: 'success',
            title: successText,
            showCancelButton: true,
reverseButtons: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: okText,
          });
          this.getStatusEncuesta(this.token)
        });
      }
    });
  }

  cierreEncuestaStatus2(){
    let warningText='AVANCES.WARNING-CIERRE-ENCUESTA';
    let successText='AVANCES.SUCCESS-CIERRE';
    let aceptarText='AVANCES.BOTONES-MODALES.ACEPTAR';
    let cancelarText='AVANCES.BOTONES-MODALES.CANCELAR';
    let okText='AVANCES.BOTONES-MODALES.OK';
    this.translateSrv.get(warningText).subscribe((res: string) => { warningText = res; });
    this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
    this.translateSrv.get(aceptarText).subscribe((res: string) => { aceptarText = res; });
    this.translateSrv.get(cancelarText).subscribe((res: string) => { cancelarText = res; });
    this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
    Swal.fire({
      title: warningText,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: aceptarText,
      cancelButtonText: cancelarText
    }).then((result) => {
      if (result.value) {
        // datos.token=this.token;
        this.surveyServ.cierreEncuestaStatus2(this.token).subscribe((resul: any)=>{
          Swal.fire({
            icon: 'success',
            title: successText,
            showCancelButton: true,
reverseButtons: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: okText,
          });
          this.getStatusEncuesta(this.token)
        });
      }
    });
  }

  modalBtnCerrarProrro(){
    let okText='AVANCES.BOTONES-MODALES.OK';
    this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
    let warningText='AVANCES.WARNING-BTN';
    this.translateSrv.get(warningText).subscribe((res: string) => { warningText = res; });
    Swal.fire({
      icon: 'warning',
      title: warningText,
      confirmButtonColor: '#3085d6',
      confirmButtonText: okText,
    });

  }
  encuesta_cerrada:boolean=false;
  getStatusEncuesta(token:string){
     this.surveyServ.getEstatusCierreEncuesta(token).subscribe((resul: any)=>{

       console.log("bloquear_btn","true",resul);
       this.statusEncuesta=resul.result.id_status
       if(this.statusEncuesta==2){
         this.encuesta_cerrada=true;
         this.bloquearBotonReminder=true;
         localStorage.setItem("bloquear_btn","true");
       }
    });
  }

   send_email(email:any,tipo:any){

      console.log("No se envian de focus");
      Swal.showLoading();
      this.idEmpresa;
      this.idProducto_tmp;
      let data:any = {
        email: email,
        tipo: tipo
      };
      let successText='AVANCES.ENCUESTA.SUCCESS1';
      if(tipo == 1){
        successText='AVANCES.ENCUESTA.SUCCESS1';
      }else{
        successText='AVANCES.ENCUESTA.SUCCESS2';
      }
      let okText='AVANCES.BOTONES-MODALES.OK';
      this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
      this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
      let errorText='AVANCES.ENCUESTA.ERROR1';
      this.translateSrv.get(errorText).subscribe((res: string) => { errorText = res; });
      this.surveyServ.send_email(data,this.idEmpresa,this.idProducto_tmp).subscribe( (data: any) => {
        console.log(data);
        Swal.close();
        if(data.message == "Success"){
          this.mensajeTrue(successText,okText);
        }else{
          this.mensajeFalse(okText,errorText);
        }
    });


  }

  sendEmail_focus(email,tipo){
    console.log("Se enviam de focus");
    Swal.showLoading();
    this.idEmpresa;
    this.idProducto_tmp;
    let data:any = {
      encuestaId: this.idFocus,
      email: email,
      tipo: tipo
    };
    console.log("Datos focus");
    console.log(data);
    let successText='AVANCES.ENCUESTA.SUCCESS1';
    if(tipo == 1){
      successText='AVANCES.ENCUESTA.SUCCESS1';
    }else{
      successText='AVANCES.ENCUESTA.SUCCESS2';
    }
    let okText='AVANCES.BOTONES-MODALES.OK';
    let errorText='AVANCES.ENCUESTA.ERROR1';
    this.translateSrv.get(errorText).subscribe((res: string) => { errorText = res; });
    this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
    this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
    console.log(this.idEmpresa);
    console.log(this.idProducto_tmp);
    this.surveyServ.send_emailfocus(data,this.idEmpresa,this.idProducto_tmp).subscribe( (data: any) => {
      console.log(data);
      Swal.close();
      if(data.message == "Success"){
        this.mensajeTrue(successText,okText);
      }else{
        this.mensajeFalse(okText,errorText);
      }
    });

  }

  mensajeTrue(successText,okText){
    Swal.fire({
      icon: 'success',
      title: successText,
      confirmButtonColor: '#3085d6',
      confirmButtonText: okText,
    });
  }
  mensajeFalse(okText,errorText){
    Swal.fire({
      icon: errorText,
      title: "Ocurrio un error",
      confirmButtonColor: '#3085d6',
      confirmButtonText: okText,
    });
  }

  getPilotoDataEncuesta(){
    let data={
      fechaCertificar: localStorage.getItem('fechaProducto')
    };
    this.encuestaService.getPilotoDataEncuesta_estatus(data,this.idEmpresa).subscribe((data: backInter.getEncuestaPilotoC2) => {
      console.log("getPilotoData:",data);

    });
  }
  auxCorreo_array:any;
  bloquearBotonReminder:boolean=false;

  Reminder(){
    this.bloquearBotonReminder=true;
    switch(this.nombreProducto){
      case 'Certify': case 'Certify3': case 'Focus 1': case 'Measure3 ': case 'Pulse3':
        console.log("Entro a certificar");
        console.log(this.Certificar_tipoProducto);
        if(this.Certificar_tipoProducto == 1){
          this. sendReminderV1();
        }else if(this.Certificar_tipoProducto == 2 || this.Certificar_tipoProducto == 3){
          this.sendReminder()
        }else if (this.Certificar_tipoProducto == 4 && this.tipoProductoSeleccionado==40) {
          console.log("No ejecuta ningun servicio esta aun pendiente ");
   this.sendReminderCertificar3();
        }
        //this.sendReminder()
      break;
      case 'NAV.PULSE.TITULO':
        this.sendReminderFocus();
      break;
      default:
        this.sendReminderMedir()
      break;
    }
  }
  sendReminderV1(){
    let texto = 'CIERRE.ALERT_RE.MESSAGE';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    let rspSi = 'CIERRE.ALERT_RE.BTN_CONFIRM';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    let rspNo ='CIERRE.ALERT_RE.BTN_CANCEL';
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        if(this.fechaLanzamiento){
          console.log(this.idProducto_tmp);
          var now = new Date();
          var date2 = new Date(now),
          mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
            day = ("0" + date2.getDate()).slice(-2);
          var timestamp1 = new Date(this.fechaLanzamiento).getTime();
          var timestamp2 = new Date(date2).getTime();
          if(timestamp2>timestamp1){
            let datos:any ={productoId:this.idProducto_tmp};
            let mensajeEspera = 'CIERRE.CARGANDOCORREO';
            this.translateSrv.get(mensajeEspera).subscribe((res: string) => { mensajeEspera = res; });
            Swal.fire({
              title: mensajeEspera,
                didOpen: () => {
                  Swal.showLoading()
                }
            });
            this.cierreService.getRecordatorios_correo_statussurvey(datos,this.idEmpresa).subscribe( (data: backInter.correosData) => {
              console.log(data);
              this.auxCorreo_array=data.recordatoriosManuales;
              if(this.auxCorreo_array.length == 0){
                this.cierreService.CertificarsendRecordatorio_statusSurvey(this.idProducto_tmp,this.idEmpresa).subscribe( (data: any) => {
                  Swal.close();
                  this.bloquearBotonReminder=false;
                  let texto = 'CIERRE.LABEL5';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                    Swal.fire({
                      title: texto,
                      icon: "success",
                      confirmButtonColor: '#e40601'
                    });

                },error=>{
                  console.log(error);
                });

              }else{
              var pos= this.auxCorreo_array.length;
              var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
              var timestampRecordatorio2 = new Date(date2).getTime();
              var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
              console.log(tiempoRecordatorios);
              if(timestamp1){
                if(tiempoRecordatorios >= 86400000){
                  this.cierreService.CertificarsendRecordatorio_statusSurvey(this.idProducto_tmp,this.idEmpresa).subscribe( (data: any) => {
                    Swal.close();
                    this.bloquearBotonReminder=false;
                    let texto = 'CIERRE.LABEL5';
                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                      Swal.fire({
                        title: texto,
                        icon: "success",
                        confirmButtonColor: '#e40601'
                      });
                    });
                 }else{
                  let texto = 'CIERRE.LABEL6';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  Swal.fire({
                    title: texto,
                    icon: "error",
                    confirmButtonColor: '#e40601'
                  });
                 }
              }
              }
            });
          }
          else{
            this.dialogDate_message(this.fechaLanzamiento);
          }
        }
      }
      this.bloquearBotonReminder=false;
    });
  }

  sendReminder(){
    let texto = 'CIERRE.ALERT_RE.MESSAGE';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    let rspSi = 'CIERRE.ALERT_RE.BTN_CONFIRM';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    let rspNo ='CIERRE.ALERT_RE.BTN_CANCEL';
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        if(this.fechaLanzamiento){
          console.log(this.idProducto_tmp);
          var now = new Date();
          var date2 = new Date(now),
          mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
            day = ("0" + date2.getDate()).slice(-2);
          var timestamp1 = new Date(this.fechaLanzamiento).getTime();
          var timestamp2 = new Date(date2).getTime();
          if(timestamp2>timestamp1){
            let datos:any ={productoId:this.idProducto_tmp};
            let mensajeEspera = 'CIERRE.CARGANDOCORREO';
            this.translateSrv.get(mensajeEspera).subscribe((res: string) => { mensajeEspera = res; });
            Swal.fire({
              title: mensajeEspera,
              didOpen: () => {
                Swal.showLoading()
              }
            });
            this.cierreService.getRecordatorios_correo_statussurvey(datos,this.idEmpresa).subscribe( (data: backInter.correosData) => {
              console.log(data);
              this.auxCorreo_array=data.recordatoriosManuales;
              if(this.auxCorreo_array.length == 0){
                this.cierreService.CertificarsendRecordatorio_statusSurveySMTP(this.idProducto_tmp,this.idEmpresa).subscribe( (data: any) => {
                  Swal.close();
                  this.bloquearBotonReminder=false;
                  let texto = 'CIERRE.LABEL5';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                    Swal.fire({
                      title: texto,
                      icon: "success",
                      confirmButtonColor: '#e40601'
                    });
                });
              }else{
              var pos= this.auxCorreo_array.length;
              var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
              var timestampRecordatorio2 = new Date(date2).getTime();
              var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
              console.log(tiempoRecordatorios);
              if(timestamp1){
                if(tiempoRecordatorios >= 86400000){
                  this.cierreService.CertificarsendRecordatorio_statusSurveySMTP(this.idProducto_tmp,this.idEmpresa).subscribe( (data: any) => {
                    Swal.close();
                    this.bloquearBotonReminder=false;
                    let texto = 'CIERRE.LABEL5';
                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                      Swal.fire({
                        title: texto,
                        icon: "success",
                        confirmButtonColor: '#e40601'
                      });
                    });
                 }else{
                  let texto = 'CIERRE.LABEL6';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  Swal.fire({
                    title: texto,
                    icon: "error",
                    confirmButtonColor: '#e40601'
                  });
                 }
              }
              }
            });
          }
          else{
            this.dialogDate_message(this.fechaLanzamiento);
          }
        }
      }
      this.bloquearBotonReminder=false;
    });
  }

  sendReminderCertificar3(){
    let texto = 'CIERRE.ALERT_RE.MESSAGE';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    let rspSi = 'CIERRE.ALERT_RE.BTN_CONFIRM';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    let rspNo ='CIERRE.ALERT_RE.BTN_CANCEL';
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        if(this.fechaLanzamiento){
          console.log(this.idProducto_tmp);
          var now = new Date();
          var date2 = new Date(now),
          mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
            day = ("0" + date2.getDate()).slice(-2);
          var timestamp1 = new Date(this.fechaLanzamiento).getTime();
          var timestamp2 = new Date(date2).getTime();
          if(timestamp2>timestamp1){
            let datos:any ={productoId:this.idProducto_tmp};
            let mensajeEspera = 'CIERRE.CARGANDOCORREO';
            this.translateSrv.get(mensajeEspera).subscribe((res: string) => { mensajeEspera = res; });
            Swal.fire({
              title: mensajeEspera,
              didOpen: () => {
                Swal.showLoading()
              }
            });
            this.cierreService.getRecordatorios_correo_statussurvey(datos,this.idEmpresa).subscribe( (data: backInter.correosData) => {
              console.log(data);
              this.auxCorreo_array=data.recordatoriosManuales;
              if(this.auxCorreo_array.length == 0){
                this.cierreService.Certificar3sendRecordatorio_statusSurveySMTP(this.idProducto_tmp,this.idEmpresa).subscribe( (data: any) => {
                  Swal.close();
                  this.bloquearBotonReminder=false;
                  let texto = 'CIERRE.LABEL5';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                    Swal.fire({
                      title: texto,
                      icon: "success",
                      confirmButtonColor: '#e40601'
                    });
                });
              }else{
              var pos= this.auxCorreo_array.length;
              var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
              var timestampRecordatorio2 = new Date(date2).getTime();
              var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
              console.log(tiempoRecordatorios);
              if(timestamp1){
                if(tiempoRecordatorios >= 86400000){
                  this.cierreService.Certificar3sendRecordatorio_statusSurveySMTP(this.idProducto_tmp,this.idEmpresa).subscribe( (data: any) => {
                    Swal.close();
                    this.bloquearBotonReminder=false;
                    let texto = 'CIERRE.LABEL5';
                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                      Swal.fire({
                        title: texto,
                        icon: "success",
                        confirmButtonColor: '#e40601'
                      });
                    });
                 }else{
                  let texto = 'CIERRE.LABEL6';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  Swal.fire({
                    title: texto,
                    icon: "error",
                    confirmButtonColor: '#e40601'
                  });
                 }
              }
              }
            });
          }
          else{
            this.dialogDate_message(this.fechaLanzamiento);
          }
        }
      }
      this.bloquearBotonReminder=false;
    });
  }

  sendReminderMedir(){
    if(this.fechaLanzamiento){
      var now = new Date();
      var date2 = new Date(now),
      mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
      day = ("0" + date2.getDate()).slice(-2);
      var timestamp1 = new Date(this.fechaLanzamiento).getTime();
      var timestamp2 = new Date(date2).getTime();
      if(timestamp2>timestamp1){
        let datos:any ={productoId: this.idProducto_tmp};
        let mensajeEspera = 'CIERRE.CARGANDOCORREO';
        this.translateSrv.get(mensajeEspera).subscribe((res: string) => { mensajeEspera = res; });
        Swal.fire({
          title: mensajeEspera,
          didOpen: () => {
            Swal.showLoading()
          }
        });
        this.cierreService.getRecordatorios_correoGenerico_status(datos,this.idEmpresa).subscribe( (data: backInter.correosData) => {
          this.auxCorreo_array=data.recordatoriosManuales;
          if(this.auxCorreo_array.length == 0){
            this.cierreService.sendRecordatorioMedirGenerico_status(this.idProducto_tmp,this.idEmpresa).subscribe( (data: any) => {
              Swal.close();
              this.bloquearBotonReminder=false;
              let texto = 'CIERRE.LABEL5';
              this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                Swal.fire({
                  title: texto,
                  icon: "success",
                  confirmButtonColor: '#e40601'
                });

            });
          }else{
            var pos= this.auxCorreo_array.length;
            var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
            var timestampRecordatorio2 = new Date(date2).getTime();
            var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
              if(timestampRecordatorio1){
                  if(tiempoRecordatorios >= 86400000){
                    this.cierreService.sendRecordatorioMedirGenerico_status(this.idProducto_tmp,this.idEmpresa).subscribe( (data: any) => {
                      Swal.close();
                    this.bloquearBotonReminder=false;
                    let texto = 'CIERRE.LABEL5';
                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                      Swal.fire({
                        title: texto,
                        icon: "success",
                        confirmButtonColor: '#e40601'
                      });

                    });
                  }else{
                    let texto = 'CIERRE.LABEL6';
                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                    Swal.fire({
                      title: texto,
                      icon: "error",
                      confirmButtonColor: '#e40601'
                    });
                  }
            }else{
              this.cierreService.sendRecordatorioMedirGenerico_status(this.idProducto_tmp,this.idEmpresa).subscribe( (data: any) => {
              Swal.close();
              this.bloquearBotonReminder=false;
              let texto = 'CIERRE.LABEL5';
              this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                Swal.fire({
                  title: texto,
                  icon: "success",
                  confirmButtonColor: '#e40601'
                });

              });

            }
          }
        });
      }else{
        let texto = 'CIERRE.LABEL7';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        Swal.fire({
          title: texto,
          icon: "error",
          confirmButtonColor: '#e40601'
        });
      }
    }
    this.bloquearBotonReminder=false;
  }
  sendReminderFocus(){

    if(this.fechaLanzamiento){
      var now = new Date();
      var date2 = new Date(now),
      mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
      day = ("0" + date2.getDate()).slice(-2);
      var timestamp1 = new Date(this.fechaLanzamiento).getTime();
      var timestamp2 = new Date(date2).getTime();
      if(timestamp2>timestamp1){
        let datos:any ={productoId:this.idProducto_tmp};
        let mensajeEspera = 'CIERRE.CARGANDOCORREO';
        this.translateSrv.get(mensajeEspera).subscribe((res: string) => { mensajeEspera = res; });
        Swal.fire({
          title: mensajeEspera,
            didOpen: () => {
            Swal.showLoading()
          }
        });
        this.cierreService.getRecordatoriosPulse_status(datos,this.idEmpresa).subscribe( (data: any) => {
          console.log("Get recordatorios");
          console.log(data);
          this.auxCorreo_array=data.recordatoriosManuales;
          if (this.auxCorreo_array.length==0) {
            let datos:any={productoId:this.idProducto_tmp, numeroFecha: 1}
            this.cierreService.sendRecordatoriosPulse_status(datos,this.idEmpresa).subscribe( (data: any) => {
              Swal.close();
              this.bloquearBotonReminder=false;
              let texto = 'CIERRE.LABEL5';
              this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                Swal.fire({
                  title: texto,
                  icon: "success",
                  confirmButtonColor: '#e40601'
                });
              });
          }else{
            var pos= this.auxCorreo_array.length;
            var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
            var timestampRecordatorio2 = new Date(date2).getTime();
            var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
            console.log(tiempoRecordatorios);
            if(timestamp1){
              if(tiempoRecordatorios >= 86400000){
                let datos:any={productoId:this.idProducto_tmp, numeroFecha: 1}
                this.cierreService.sendRecordatoriosPulse_status(datos,this.idEmpresa).subscribe( (data: any) => {
                  Swal.close();
                this.bloquearBotonReminder=false;
                let texto = 'CIERRE.LABEL5';
                this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  Swal.fire({
                    title: texto,
                    icon: "success",
                    confirmButtonColor: '#e40601'
                  });
                });
              }else{
                let texto = 'CIERRE.LABEL6';
                this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                Swal.fire({
                  title: texto,
                  icon: "error",
                  confirmButtonColor: '#e40601'
                });
              }
            }
          }
        });
      }else{
        Swal.close();
        let texto = 'CIERRE.LABEL7';
         this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
         Swal.close();
            Swal.fire({
            title: texto,
            icon: "error",
            confirmButtonColor: '#e40601'
         });
      }
    }
    this.bloquearBotonReminder=false;
  }



  fechaSeleccionada(event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    let fechaMoment = moment(fechaElegida).format('YYYY-MM-DD');
    let fechaAnterior = this.fechaProrroga;
    console.log("fechaEvent:",fechaElegida);
    console.log("fechaMoment:",fechaMoment);
    this.fechaProrroga = fechaMoment;
    setTimeout(() => {
        $("#timepicker").click();
    }, 200);
  }

  horaSeleccionada(event){
    console.log("horaSel:",event);
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechaProrroga = this.fechaProrroga + " " + hora24;

    // let fechaActual = moment();
    let fechaActual = momentTz.tz(this.zonasUTC[this.indiceZona].zona);

    let fechaActualLocal = moment().utc(true);
    let fechaActualInsti = momentTz.tz(this.zonasUTC[this.indiceZona].zona).utc(true);
    let diferenciaLocalInstituto = fechaActualLocal.diff(fechaActualInsti, 'seconds');
    let fechaElegidaAjustada: any;
    if(diferenciaLocalInstituto < 0){
      fechaElegidaAjustada = momentTz.tz(this.zonasUTC[this.indiceZona].zona).subtract((diferenciaLocalInstituto*-1), 'seconds');
    }
    else{
      fechaElegidaAjustada = momentTz.tz(this.zonasUTC[this.indiceZona].zona).add(diferenciaLocalInstituto, 'seconds');
    }
    let utcActual = moment.utc();
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    let fechaSeleccionada = momentTz.tz(this.fechaProrroga,this.zonasUTC[this.indiceZona].zona);
    let diferenciaMinutos = momentTz.tz(this.fechaProrroga,this.zonasUTC[this.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'minutes'); //se le añade 1 minutos porque siempre se desfasa alv -_-

    console.log("utcActual:",utcActual.format());
    console.log("fechaActual:",fechaActual.format());
    console.log("fechaActualLocal:",fechaActualLocal.format());
    console.log("diferenciaLocalInstituto:",diferenciaLocalInstituto);
    console.log("fechaElegidaAjustada:",fechaElegidaAjustada.format());
    console.log("diferenciaUtc:",diferenciaUtc);
    console.log("fechaSeleccionada:",fechaSeleccionada.format());
    console.log("diferenciaMinutos:",diferenciaMinutos);
    console.log("fechaActualTransformada:",fechaActualTransformada.format());
    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.utc(true).toISOString());

    //guarda la fecha final ajustada a utc
    this.fechaProrroga = moment(fechaActual).add(diferenciaMinutos, 'seconds').add(1, 'minutes').utc(true).toISOString();
    console.log("Esta fecha esta en  Formato UTC0: ", this.fechaProrroga);

   this.saveActualizarFechaCierreProrroga(fechaTransformadaMasDifUtc.utc(true).toISOString());


  }


  generarClave(){
    let datos:any;
    if (this.tipoProductoClaveConteos==4) {
      datos={empresaId: localStorage.getItem('idEmpresa_surveysatus'),productoId:localStorage.getItem('productoID'),claveProducto: this.tipoProductoClaveConteos,idSurvey: parseInt(localStorage.getItem('idSurvey_status'))};
    }else{
      datos={empresaId: localStorage.getItem('idEmpresa_surveysatus'),productoId:localStorage.getItem('productoID'),claveProducto: this.tipoProductoClaveConteos};
    }
    console.log('datos*******',datos);

    this.cierreService.saveConteosClaves(datos).subscribe( (data: backInter.getClaveConteos) => {
      this.claveConteos= data.clave._id;
      console.log(this.claveConteos);
      console.log(data);
      this.getClaveConteo();
    });
  }

  getClaveConteo(){
    let datos:any ={empresaId: localStorage.getItem('idEmpresa_surveysatus'),productoId:localStorage.getItem('productoID')};
    console.log(datos);
    this.cierreService.getClaveConteos(datos).subscribe( (data: backInter.getClaveConteos) => {
      console.log(data);
      if (data.success==true) {
        this.claveConteos= data.clave._id;
        console.log(this.claveConteos);
        this.mostrarBtnCopyEnl=true;

      }else{
        console.log("aun sin clave");
        this.mostrarBtnCopyEnl=false;
      }
    });

  }

  getClaveConteoPulse(){
    let datos:any ={empresaId: localStorage.getItem('idEmpresa_surveysatus'),productoId:localStorage.getItem('productoID')};
    console.log(datos);
    this.cierreService.getClavesConteosPulse(datos).subscribe( (data: backInter.getClaveConteosPulse) => {
      console.log(data);
      if (data.success==true) {
     this.claveConteos= data.claves[0]._id;
     console.log("tus claves son");
     console.log(this.claveConteos);
     this.mostrarBtnCopyEnl=true;
   }else{
     console.log("aun sin clave");
     this.mostrarBtnCopyEnl=false;
   }
    });

}

  copyMessageUrlCon(val: string, getUrl?:boolean){
    let texto = 'CIERRE.CIERRE.COPYLINK';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    // let url = DATOS_API.url.split(":");
    // this.rutaPagina = url[1] + "/surveyadministrator/counting/" + val;
    if(getUrl){
      this.rutaPagina = val;
    }
    else{
      this.rutaPagina = DATOS_API.urlConteos + val;
    }
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    // selBox.value=val;
    selBox.value=this.rutaPagina;
    console.log(this.rutaPagina);
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    Swal.fire({
      icon: 'success',
      title: texto,

      confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
    });

  }

}

@Component({
  selector: 'SurveyDialog',
  templateUrl: './dialogEncuesta.dialog.component.html',
  styleUrls: ['./dialogEncuesta.component.scss'],
  animations : fuseAnimations
})


export class SurveyDialog {

  //private _unsubscribeAll: Subject<any>;
  informacion:any;
  cargandoCitas:boolean=true;
  idiomaActual:string;
  city_name:any;
  bloquear_Btn:boolean;
  constructor(
    private _formBuilder: FormBuilder,
    private activatedRoute : ActivatedRoute,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public authService: AuthService,
    private surveyServ: SurveyStatusService,
    public dialogRef: MatDialogRef<SurveyDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    let bloqueo=localStorage.getItem("bloquear_btn");
    if(bloqueo== "true"){
      this.bloquear_Btn=true;
    }else{
      this.bloquear_Btn=false;
    }
    lang_avances.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.informacion=data;
    console.log(this.informacion);
    this.idiomaActual = this.translateSrv.currentLang;
    if(this.informacion.idSurveyMas || this.informacion.idSurveyMenos){
      this.avanceSurveyNorma(this.informacion.SurveyId,this.informacion.surveyKey,this.informacion.idEmpresa,this.informacion.idSurveyMenos,this.informacion.idSurveyMas);
    }else{
      this.avanceSurvey(this.informacion.SurveyId,this.informacion.surveyKey,this.informacion.idEmpresa);
    }
    this.datosEmpresa(this.informacion.idEmpresa);
   }
    name:any;
    fechaInicio:any;
    fechaFin:any;
    status:any;
    cargandoSurvey:boolean=false;
    sin_fechaInicio:boolean=false;
    sin_fechaFin:boolean=false;

   avanceSurvey(SurveyId,surveyKey,idEmpresa,SurveyIdMenos?,SurveyIdMas?){
    let texto = 'AVANCES.ENCUESTA.NA';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.fechaInicio=texto;
    this.fechaFin=texto;
    this.surveyServ.getEstatus(SurveyId,surveyKey,idEmpresa).subscribe( (data: any) => {
      console.log(data);
      this.name=data.fullName;
      if(data.fechaIn){
        this.sin_fechaInicio=true;
        console.log("Entro fecha inicio "+data.fechaIn);
        console.log("instituto "+localStorage.getItem('instituto_id'));
        switch(localStorage.getItem('instituto_id')){
          case '1': this.fechaInicio=new Date(data.fechaIn).toLocaleString('es-MX', { timeZone: 'Mexico/BajaSur' }); break;
          case '2': this.fechaInicio=new Date(data.fechaIn).toLocaleString('es-MX', { timeZone: 'Mexico/BajaSur' });  break;
          case '3': this.fechaInicio=new Date(data.fechaIn).toLocaleString('zh-HK', { timeZone: 'Asia/Hong_Kong' });  break;
          case '4': this.fechaInicio=new Date(data.fechaIn).toLocaleString('zh-TW', { timeZone: 'Asia/Singaporer' });  break;
          case '5': this.fechaInicio=new Date(data.fechaIn).toLocaleString('tr-TR', { timeZone: 'Asia/Ashgabat' });  break;
          case '6': this.fechaInicio=new Date(data.fechaIn).toLocaleString('zh-TW', { timeZone: 'Asia/Manila' });  break;
          case '11': this.fechaInicio=new Date(data.fechaIn).toLocaleString('pt-BR', { timeZone: 'America/Araguaina' });  break;
        }
      }else{
        console.log("Entro");
        this.fechaInicio=texto;
      }
      if(data.fechaFin){
        this.sin_fechaFin=true;
        console.log("Entro fecha fin "+data.fechaIn);
        console.log("instituto "+localStorage.getItem('instituto_id'));
        switch(localStorage.getItem('instituto_id')){
          case '1': this.fechaFin=new Date(data.fechaFin).toLocaleString('es-MX', { timeZone: 'Mexico/BajaSur' });break;
          case '2': this.fechaFin=new Date(data.fechaFin).toLocaleString('es-MX', { timeZone: 'Mexico/BajaSur' });  break;
          case '3': this.fechaFin=new Date(data.fechaFin).toLocaleString('zh-HK', { timeZone: 'Asia/Hong_Kong' });  break;
          case '4': this.fechaFin=new Date(data.fechaFin).toLocaleString('zh-TW', { timeZone: 'Asia/Singaporer' });  break;
          case '5': this.fechaFin=new Date(data.fechaFin).toLocaleString('tr-TR', { timeZone: 'Asia/Ashgabat' });  break;
          case '6': this.fechaFin=new Date(data.fechaFin).toLocaleString('zh-TW', { timeZone: 'Asia/Manila' });  break;
          case '11': this.fechaFin=new Date(data.fechaFin).toLocaleString('pt-BR', { timeZone: 'America/Araguaina' });  break;
        }
      }else{
        this.fechaFin=texto;
      }
      switch (data.idStatus){
        case 1:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO1";
        break;
        case 2:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO2";
        break;
        case 3:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO3";
        break;
        case 4:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO4";
        break;
      }
      this.cargandoSurvey=true;
    });
  }
  rutaimagen:any;
  nombreEmpresa:any;
  datosEmpresa(idEmpresa){
    this.surveyServ.getInfoEmpresa(idEmpresa).subscribe((data:backInter.infoEmpresa) => {
      if(data){
        let url = DATOS_API.url.split(":");
        this.rutaimagen= url[1]+"/surveyadministrator/backend/"+data.data.logoEmpresa;
        this.nombreEmpresa=data.data.nombreEmpresa;
      }
    }, error  => {
      console.log("error");
    });
  }

  avanceSurveyNorma(SurveyId,surveyKey,idEmpresa,SurveyIdMenos?,SurveyIdMas?){
    this.surveyServ.getEstatusNorma(SurveyIdMenos,SurveyIdMas,surveyKey,idEmpresa).subscribe( (data: any) => {
      this.name=data.fullName;
      console.log(data);
      if(data.fechaIn){
        this.fechaInicio=new Date(data.fechaIn).toLocaleString('es-MX', { timeZone: 'Mexico/BajaSur' });
      }else{
        this.fechaInicio="N/A";
      }
      if(data.fechaFin){
        this.fechaFin=new Date(data.fechaFin).toLocaleString('es-MX', { timeZone: 'Mexico/BajaSur' });
      }else{
        this.fechaFin="N/A";
      }
      switch (data.idStatus){
        case 1:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO1";
        break;
        case 2:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO2";
        break;
        case 3:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO3";
        break;
        case 4:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO4";
        break;
      }
      this.cargandoSurvey=true;
    });
  }
}

@Component({
  selector: 'Email_ActionDialog',
  templateUrl: './Email_Action.dialog.component.html',
  styleUrls: ['./dialogEncuesta.component.scss'],
  animations : fuseAnimations
})

export class EmailAction_Dialog{
  asuntosCAyC=[
    'Invitación a la encuesta de Great Place to Work® Institute',
    'Great Place to Work Institute Central America & Caribbean'
  ];

  asuntosHK=[
    '邀請函',
    'Great Place to Work Survey',
    'Invitation - Great Place to Work Survey'
  ];
  asuntosTR=[
    'Great Place to Work® Çalışan Anketi',
    'Reminder'
  ];

  MXasuntosEsp=[ // Solo instituto México
    'Great Place to Work For All_Be Great “Recordatorio“',
    'Great Place to Work For All_Be Great “Encuesta de Clima laboral”',
    'Great Place to Work For All_Be Great “Espérala”',
    'Great Place to Work For All_Be Great “Próximamente”',
  ];
  MXasuntosPor=[ // Solo instituto México
    'Convite',
    'Great Place to Work For All_Be Great “Espérala”',
    'Great Place to Work For All_Be Great "Espera por ela"',
    'Great Place to Work For All_Be Great “Em breve”'
  ];

  MxasuntosIngles=[ // Solo instituto México
    'Great Place to Work For All_Be Great “Reminder“',
    'Great Place to Work For All_Be Great “Work Climate Survey“',
    'Great Place to Work For All_Be Great "Wait for it"',
    'Great Place to Work For All_Be Great "Coming Soon"',
  ];

  AsuntosNom=[
    "Invitación de participación NOM-035-STPS-2018",
    "Recordatorio de participación NOM-035-STPS-2018",
    "Recordatorio de participación NOM-035-STPS-2018",
    "Recordatorio de participación NOM-035-STPS-2018",
    "Inicio de participación NOM-035-STPS-2018",
    "Acceso a NOM-035-STPS-2018",
    "Gracias por tu participación NOM-035-STPS-2018",
    "No dejes de participar NOM-035-STPS-2018"
  ];
  AsuntoGeneral=[];
  idiomasNativo:any;
  Valorasunto:any;
  lookingFor:boolean=false;
  historial:any;
  correo:any;
  Nohistorial:boolean=false;

  dataEmail:any;
  bloquearBtn:boolean;
  offsetPipe:any;
  idiomaActual:any;
  city_name:any;
  bloquear_Btn:boolean;
  //this.idiomaActual = this.translateSrv.currentLang;
  constructor(
    private _formBuilder: FormBuilder,
    private activatedRoute : ActivatedRoute,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public authService: AuthService,
    private surveyServ: SurveyStatusService,
    public dialogRef: MatDialogRef<EmailAction_Dialog>,
    private colaboradoresService: ColaboradoresEncuestadorService,
    private logService:SendGridService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataEmail
  ) {

    //console.log("Bloqueo de botón "+this.bloquear_Btn);
    this.city_name=localStorage.getItem('nameCity_surveystatus');
    console.log("city name "+this.city_name);
    lang_avances.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    console.log(data);
    this.dataEmail=data;


    if(!this.dataEmail.cerrarEncuesta){
      let  now = new Date();
      let fechaDeLanzamiento=new Date(this.dataEmail.fechaLanzamiento);
      if(now<fechaDeLanzamiento || this.dataEmail.email == "*"){
        this.bloquear_Btn=true;
      }else{
        this.bloquear_Btn=false;
        let bloqueo=localStorage.getItem("bloquear_btn");
        console.log("Bloqueo "+bloqueo);

      }
      if(this.dataEmail.estaadoEncuesta){
        if(this.dataEmail.estaadoEncuesta != 4){
          this.bloquearBtn=false;
        }else{
          this.bloquearBtn=true;
        }
      }
    }else{
      this.bloquearBtn=true;
    }

    this.getIdioma();
    this.obtener_infoTemplate()
    this.offsetPipe=localStorage.getItem("offsetPipe_tmp");
   }

   getIdioma(){
     console.log("Tipo de producto "+this.dataEmail.nombreProducto);
     switch(this.dataEmail.nombreProducto){
       case 'Certificar': // Certificar
         let datos = { productoId: this.dataEmail.idProducto};
         this.logService.getIdiomas(datos,this.dataEmail.idEmpresa).subscribe( (data: any) => {
           console.log(data);
           if(data.idiomasMostrar){this.asignarSelect(data);}
         });
       break;
       case 'Medir mejorador': case 'Medir MTS': case 'Medir áreas': case 'Medir líderes': case 'Medir dimencione': case 'Medir certificar'://Medir
         let fechaProducto = {productoId: this.dataEmail.idProducto};
         this.logService.getIdiomasMedir(fechaProducto,this.dataEmail.idEmpresa).subscribe( (data: any) => {
           if(data.idiomasMostrar){this.asignarSelect(data);}

       });
       break;
       case 'PulseCheck': //Medir generico
       let datosPulse={productoId:this.dataEmail.idProducto}
       this.logService.getIdiomasProdPulse(datosPulse,this.dataEmail.idEmpresa).subscribe( (data: any) => {
         if(data.idiomasMostrar){this.asignarSelect(data);}

       });

       break;
       default:
         //console.log("Asuntos norma");
         this.AsuntoGeneral=this.AsuntosNom;
       break;
     }

   }
    informacionTemplate:any;
   obtener_infoTemplate(){
    let dataTemplate:any = {productoId: this.dataEmail.idProducto}
    this.surveyServ.informacion_template(this.dataEmail.idEmpresa,dataTemplate).subscribe( (data: any) => {
      console.log("Información template");
      if(data.message== 'Success'){
        this.informacionTemplate=data.generalCorreos;
      }
      console.log(data);

    });
  }

   asignarSelect(data){
     this.idiomasNativo=data.idiomasMostrar[0].nombreIdioma;
     console.log("Idioma nativo "+this.idiomasNativo);
       switch (this.dataEmail.instituto){
         case 1:
           switch (this.idiomasNativo){
             case "en":
               this.AsuntoGeneral=this.MxasuntosIngles;
             break;
             case "es":
               this.AsuntoGeneral=this.MXasuntosEsp;
             break;
             case "pr":
               this.AsuntoGeneral=this.MXasuntosPor;
             break;
             }
           break;

         case 2:
           this.AsuntoGeneral=this.asuntosCAyC;
           // this.AsuntoGeneral=this.MXasuntosEsp;
         break;
         case 3:
           this.AsuntoGeneral=this.asuntosHK;
         break;
         case 5:
           this.AsuntoGeneral=this.asuntosTR;
         break;
         case 15:
           this.AsuntoGeneral=this.MXasuntosEsp;
         break;
     }
   }

   onChange(deviceValue) {
     this.lookingFor=true;
     console.log(deviceValue.value);
     this.Valorasunto=deviceValue.value;
   }

   getEmail(){
     let cargando = 'MODALES.LOG_SENDGRIND.CARGANDO';
     let mensaje = 'MODALES.LOG_SENDGRIND.ASUNTO';
     let cerrar = 'MODALES.LOG_SENDGRIND.CONFIRMAR';

     this.translateSrv.get(cargando).subscribe((res: string) => { cargando = res; });
     this.translateSrv.get(mensaje).subscribe((res: string) => { mensaje = res; });
     this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });

     if(this.Valorasunto){
       this.historial=[];
       this.correo=this.dataEmail.email;
       Swal.fire({
         title: cargando,
         didOpen: () => {
           Swal.showLoading()
         }
       });
       this.logService.getStatusEmail(this.dataEmail.email,this.Valorasunto.asunto).subscribe( (data: any) => {
         console.log(data);
         this.historial=data.log.messages;
         if(this.historial.length > 0){
           this.Nohistorial=true;
         }else{
           this.Nohistorial=false;
         }
         Swal.close();
         this.sendgrindDialog(data,this.Valorasunto, this.Nohistorial, this.correo);
       });
     }else if(this.Valorasunto== 'Seleccione una opción' || this.Valorasunto== 'Select an option' || !this.Valorasunto){
       Swal.fire({
         icon: 'warning',
         title: mensaje,

         confirmButtonText: cerrar
       })
     }
   }

   sendgrindDialog(data:any, valorAsunto:string, nohistorial:boolean, correo:string): void {
     let dataModal: any;
     const dialogRef = this.dialog.open(DialogInfo, {
       width: '600px', height: '400px', autoFocus: false,
       data:{
         datos:data,
         valorAsunto:valorAsunto,
         noHistorial:nohistorial,
         correo:correo
       }

     });
     dialogRef.afterClosed().subscribe(result => {
     });
   }

   send_email(tipo:any){
    Swal.showLoading();
    if(this.dataEmail.nombreProducto != "Focus Area"){
      let data:any
      console.log("Producto certificar, medir");
      if (tipo==1) {
        data = {
          email: this.dataEmail.email,
          tipo: tipo
        };
      }else{
        if (this.dataEmail.tipoProducto==40||this.dataEmail.tipoProducto==41||this.dataEmail.tipoProducto==42||this.dataEmail.tipoProducto==43) {
          if (this.dataEmail.estaadoEncuesta==1) {
            data = {
              email: this.dataEmail.email,
              tipo: 6
            };
          }else{
            data = {
              email: this.dataEmail.email,
              tipo: 7
            };
          }

        }else{
          data = {
            email: this.dataEmail.email,
            tipo: 2
          };
        }
      }
      console.log('data:::::',data);

      let successText='AVANCES.ENCUESTA.SUCCESS1';
      if(tipo == 1){
        successText='AVANCES.ENCUESTA.SUCCESS1';
      }else{
        successText='AVANCES.ENCUESTA.SUCCESS2';
      }
      let okText='AVANCES.BOTONES-MODALES.OK';
      this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
      this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
      let errorText='AVANCES.ENCUESTA.ERROR1';
      this.translateSrv.get(errorText).subscribe((res: string) => { errorText = res; });
      this.surveyServ.send_email(data,this.dataEmail.idEmpresa,this.dataEmail.idProducto).subscribe( (data: any) => {
        console.log(data);
        Swal.close();
        if(data.message == "Success"){
          this.mensajeTrue(successText,okText);
        }else{
          this.mensajeFalse(okText,errorText);
        }
      });
    }else{
       console.log("Productos focus area");
      this.sendEmail_focus(tipo);
    }

  }

  sendEmail_focus(tipo){
    Swal.showLoading();
    let data:any = {
      encuestaId: this.dataEmail.encuestaId,
      email: this.dataEmail.email,
      tipo: tipo
    };
    let successText='AVANCES.ENCUESTA.SUCCESS1';
    if(tipo == 1){
      successText='AVANCES.ENCUESTA.SUCCESS1';
    }else{
      successText='AVANCES.ENCUESTA.SUCCESS2';
    }
    let okText='AVANCES.BOTONES-MODALES.OK';
    let errorText='AVANCES.ENCUESTA.ERROR1';
    this.translateSrv.get(errorText).subscribe((res: string) => { errorText = res; });
    this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
    this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
    this.surveyServ.send_emailfocus(data,this.dataEmail.idEmpresa,this.dataEmail.idProducto).subscribe( (data: any) => {
      Swal.close();
      if(data.message == "Success"){
        this.mensajeTrue(successText,okText);
      }else{
        this.mensajeFalse(okText,errorText);
      }
    });
  }

  sendEmail_norma(tipo){
    Swal.showLoading();
    let data:any = {
      encuestaId: this.dataEmail.encuestaId,
      email: this.dataEmail.email,
      tipo: tipo
    };
    let successText='AVANCES.ENCUESTA.SUCCESS1';
    if(tipo == 1){
      successText='AVANCES.ENCUESTA.SUCCESS1';
    }else{
      successText='AVANCES.ENCUESTA.SUCCESS2';
    }
    let okText='AVANCES.BOTONES-MODALES.OK';
    let errorText='AVANCES.ENCUESTA.ERROR1';
    this.translateSrv.get(errorText).subscribe((res: string) => { errorText = res; });
    this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
    this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
    this.surveyServ.send_emailnorma(data,this.dataEmail.idEmpresa,this.dataEmail.idProducto).subscribe( (data: any) => {
      Swal.close();
      if(data.message == "Success"){
        this.mensajeTrue(successText,okText);
      }else{
        this.mensajeFalse(okText,errorText);
      }
    });
  }

  emailColaborador:any;
  //borrar_respuestas(){
    /*let message='AVANCES.BOTONES-MODALES.MESSAGE';
    let resp_yes='AVANCES.BOTONES-MODALES.RESP_SI';
    let resp_no='AVANCES.BOTONES-MODALES.RESP_NO';
    this.translateSrv.get(message).subscribe((res: string) => { message = res; });
    this.translateSrv.get(resp_yes).subscribe((res: string) => { resp_yes = res; });
    this.translateSrv.get(resp_no).subscribe((res: string) => { resp_no = res; });
    message=message+this.dataEmail.username+'?'
    Swal.fire({
      title: message,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: resp_yes,
      cancelButtonText: resp_no,
    }).then((result) => {
      if (result.value) {

        this.colaboradoresService.getColaboradoresActualizarFull(this.dataEmail.fecha, this.dataEmail.idProducto,this.dataEmail.idEmpresa).subscribe( (getFull: colabInter.getBDFull) => {
          Swal.showLoading();
          console.log(getFull);
          for(let i=0; i < getFull.bdcolaboradores.length; i++){
            if(getFull.bdcolaboradores[i].email == this.dataEmail.email){
              this.emailColaborador=getFull.bdcolaboradores[i]._id;
              break;
            }
          }
          console.log("Correo "+this.emailColaborador);
          let dataDelete:any ={
            tokenSurvey : this.dataEmail.tokenConfig
          }
          this.surveyServ.delete_surveyAnswer(this.emailColaborador,this.dataEmail.instituto,dataDelete).subscribe( (data: any) => {
            console.log(data);
            Swal.close();
            if(data.success){
              let successText='AVANCES.BOTONES-MODALES.SUCCESS-DELETE';
              let okText='AVANCES.BOTONES-MODALES.OK';
              this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
              this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
              this.mensajeTrue(successText,okText);
            }else{
              let errorText='AVANCES.BOTONES-MODALES.ERROR-DELETE';
              let okText='AVANCES.BOTONES-MODALES.OK';
              this.translateSrv.get(errorText).subscribe((res: string) => { errorText = res; });
              this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
              this.mensajeFalse(okText,errorText);
            }

          });
        });
      }
    });*/

    /* */

  //}

  mensajeTrue(successText,okText){
    Swal.fire({
      icon: 'success',
      title: successText,
      confirmButtonColor: '#3085d6',
      confirmButtonText: okText,
    });
  }
  mensajeFalse(okText,errorText){
    Swal.fire({
      icon: 'error',
      title: errorText,
      confirmButtonColor: '#3085d6',
      confirmButtonText: okText,
    });

  }

  borrar_respuestas(){
    let mensajeTexto1 = 'AVANCES.BOTONES-MODALES.ELIMINAR.MESSAGE1';
    let mensajeTexto2 = 'AVANCES.BOTONES-MODALES.ELIMINAR.MESSAGE2';
    let confirmarEmpresa = 'AVANCES.BOTONES-MODALES.ELIMINAR.VALIDAR';
    let salir = 'AVANCES.BOTONES-MODALES.ELIMINAR.SALIR';
    let errorNombreEmpresa = 'AVANCES.BOTONES-MODALES.ELIMINAR.ERRORNOMBREEMPRESA';

    let mensaje = 'AVANCES.BOTONES-MODALES.ELIMINAR.MENSAJE';
    let cancelar = 'AVANCES.BOTONES-MODALES.ELIMINAR.CANCELAR';
    let confirmar = 'AVANCES.BOTONES-MODALES.ELIMINAR.CONFIRMAR';
    let success = 'AVANCES.BOTONES-MODALES.ELIMINAR.SUCCES';
    let cerrar = 'AVANCES.BOTONES-MODALES.ELIMINAR.CERRAR';

    this.translateSrv.get(mensajeTexto1).subscribe((res: string) => { mensajeTexto1 = res; });
    this.translateSrv.get(mensajeTexto2).subscribe((res: string) => { mensajeTexto2 = res; });
    this.translateSrv.get(confirmarEmpresa).subscribe((res: string) => { confirmarEmpresa = res; });
    this.translateSrv.get(salir).subscribe((res: string) => { salir = res; });
    this.translateSrv.get(errorNombreEmpresa).subscribe((res: string) => { errorNombreEmpresa = res; });

    this.translateSrv.get(mensaje).subscribe((res: string) => { mensaje = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(success).subscribe((res: string) => { success = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    let mensajeTexto3 = 'AVANCES.BOTONES-MODALES.ELIMINAR.MESSAGE3';
    this.translateSrv.get(mensajeTexto3).subscribe((res: string) => { mensajeTexto3 = res; });
    Swal.fire({
      title: mensajeTexto3+'<font color="red">'+this.dataEmail.username+'</font>' + '</span>',
      icon: 'info',
      input:'text',
      showCancelButton: true,
reverseButtons: true,


      cancelButtonText: salir,
      confirmButtonText: confirmarEmpresa
    })
    .then( (borrar) => {
      console.log(borrar);
      if (borrar.value==this.dataEmail.username) {
        Swal.fire({
          title: mensaje + this.dataEmail.username,
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,


          cancelButtonText: cancelar,
          confirmButtonText: confirmar
        })
        .then( (borrar) => {
          Swal.showLoading();
          console.log(borrar);
          if (borrar.value) {
            Swal.showLoading();
            this.colaboradoresService.getColaboradoresActualizarFull(this.dataEmail.fecha, this.dataEmail.idProducto,this.dataEmail.idEmpresa).subscribe( (getFull: colabInter.getBDFull) => {
              Swal.showLoading();
              console.log(getFull);
              for(let i=0; i < getFull.bdcolaboradores.length; i++){
                if(getFull.bdcolaboradores[i].email == this.dataEmail.email){
                  this.emailColaborador=getFull.bdcolaboradores[i]._id;
                  break;
                }
              }
              console.log("Correo "+this.emailColaborador);
              let dataDelete:any ={
                tokenSurvey : this.dataEmail.tokenConfig
              }
              console.log(dataDelete);

              this.surveyServ.delete_surveyAnswer(this.emailColaborador,this.dataEmail.instituto,dataDelete).subscribe( (data: any) => {
                console.log(data);
                Swal.close();
                if(data.success){
                  let successText='AVANCES.BOTONES-MODALES.SUCCESS-DELETE';
                  let okText='AVANCES.BOTONES-MODALES.OK';
                  this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
                  this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
                  this.mensajeTrue(successText,okText);
                }else{
                  let errorText='AVANCES.BOTONES-MODALES.ERROR-DELETE';
                  let okText='AVANCES.BOTONES-MODALES.OK';
                  this.translateSrv.get(errorText).subscribe((res: string) => { errorText = res; });
                  this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
                  this.mensajeFalse(okText,errorText);
                }

              });
            });
          }
        });
      }
      else{
        if(!borrar.dismiss){
          Swal.fire({
          icon: 'error',
          title: errorNombreEmpresa,
          showConfirmButton: true,

          confirmButtonText: cerrar
          })
        }

      }
    });
  }
}

@Component({
  selector: 'SurveyCheck',
  templateUrl: './surveyCheckDialog.dialog.component.html',
  styleUrls: ['./surveyCheck.component.scss'],
  animations : fuseAnimations
})


export class SurveyCheckComponent implements OnInit {
  idiomaActual:string;
  displayedColumns: string[] = ['section', 'value'];
  tablaDatos:any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SurveyCheckComponent>,
    private translateSrv: TranslateService
  ) {
    this.idiomaActual = this.translateSrv.currentLang;

    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
  }

  ngOnInit() {
    console.log(this.data.datos);
    this.cargarTabla();
  }

  cargarTabla(){
    this.tablaDatos= new MatTableDataSource(this.data.datos);
  }

  salir() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'DialogInfo',
  templateUrl: './sendgrid-log.dialog.component.html',
  styleUrls: ['./sendgrid-log.component.scss'],
  animations : fuseAnimations
})
export class DialogInfo {
  informacion:any;
  valorAsunto:any;
  noHistorial:boolean;
  historial:any;
  correo:string;
  offsetPipe:any;
  idiomaActual:any;
  city_name:any;
  constructor(
    public dialogRef: MatDialogRef<DialogInfo>,
    private translateSrv: TranslateService,
   @Inject(MAT_DIALOG_DATA) public data: Data
    ){
      this.city_name=localStorage.getItem('nameCity_surveystatus');
      console.log("City name "+this.city_name);
      console.log(localStorage.getItem('instituto_id'));
      this.informacion=data;
      this.valorAsunto=data.valorAsunto;
      this.noHistorial=data.noHistorial;
      this.correo=data.correo;
      console.log(this.informacion);
      this.historial=data.datos.log.messages;
      this.offsetPipe=localStorage.getItem("offsetPipe_tmp");
      this.idiomaActual = this.translateSrv.currentLang;
    }

    onNoClick(): void {
      this.dialogRef.close();
    }

}


@Component({
  selector: 'FechaProrrogaComponent',
  templateUrl: './fechaProrroga.dialog.component.html',
  styleUrls: ['./surveyCheck.component.scss'],
  animations : fuseAnimations
})


export class FechaProrrogaComponent implements OnInit {
  idiomaActual:string;
  idProd=localStorage.getItem('idProd');
  idEmp=localStorage.getItem('idEmp');
  fechaProrrogaBackUtc0=localStorage.getItem('fechaProrrogaBackUtc0');
  tok=localStorage.getItem('tok');
  datos:any;

  zonasUTC = zonasUTC;
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string


  constructor(
    public dialogRef: MatDialogRef<FechaProrrogaComponent>,
    private translateSrv: TranslateService,
    private surveyServ: SurveyStatusService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    console.log("offsetPipe:",this.offsetPipe);
    this.offsetPipe=localStorage.getItem("offsetPipe_tmp");
  }

  ngOnInit() {
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == parseInt(localStorage.getItem('instituto_id')));
    this.calculoOffsetPipe();
  }

  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }


//
saveProrrogaEncuesta(){

this.datos={
  productoId:this.idProd,
  empresaId:this.idEmp,
  fecha:this.fechaProrrogaBackUtc0,
  token:this.tok,
}

let datos2={
  productoId:this.idProd,
  empresaId:this.idEmp,
  fecha:this.fechaProrrogaBackUtc0,
}
console.log("fdsf,ssmdsndjsda",this.datos);
console.log(datos2);
  this.surveyServ.saveActualizarFechaCierre(this.datos).subscribe((result:any)=>{
    this.surveyServ.actualizarFechadeCierre(datos2).subscribe((dataresult:any)=>{
      console.log(dataresult);
    });
    //Actualizar
  console.log(result);
  let successText='AVANCES.SUCCESS-PRORROGA';
  let okText='AVANCES.BOTONES-MODALES.OK';
  this.translateSrv.get(successText).subscribe((res: string) => { successText = res; });
  this.translateSrv.get(okText).subscribe((res: string) => { okText = res; });
  Swal.fire({
    icon: 'success',
    title: successText,
    showCancelButton: false,
    confirmButtonColor: '#3085d6',
    // cancelButtonColor: '#d33',
    confirmButtonText: okText,
  })

this.salir();


  });
}


  salir() {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'DateMessageComponent',
  templateUrl: './DateMessage.dialog.component.html',
  styleUrls: ['./surveyCheck.component.scss'],
  animations : fuseAnimations
})

export class DateMessageComponent implements OnInit {
  idiomaActual:string;
  fecha_meesage=localStorage.getItem('fechamessage');
  datos:any;
  offsetPipe: string


  constructor(
    public dialogRef: MatDialogRef<DateMessageComponent>,
    private translateSrv: TranslateService,
    private surveyServ: SurveyStatusService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    lang_cierre.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    this.fecha_meesage=localStorage.getItem('fechamessage');
    this.offsetPipe=localStorage.getItem('offsetPipe_message');
  }

  ngOnInit() {

  }

  salir() {
    this.dialogRef.close();
  }
}
